export const de = {
	translation: {
		"--": "--",
		gallery: {
			gallery: "Galerie",
		},
		resource_links: {
			resource_links: "Ressourcen-Links",
			add_resource_link: "Ressourcen-Link hinzufügen",
			edit_resource_link: "Ressourcen-Link bearbeiten",
			no_resource_links: "Keine Ressourcen-Links vorhanden",
			link: "Link",
			name: "Name",
			links: "Links",
			types: {
				trimble: "Trimble",
			},
			not_found: "Dieser Link existiert nicht mehr.",
		},
		image_annotator: {
			image_editor: "Bildeditor",
			pick_annotation: "Annotation auswählen",
			annotations: "Annotationen",
			no_annotations_yet: "Noch keine Annotationen",
			edit_annotations: "Annotationen bearbeiten",
			show_annotations: "Annotationen anzeigen",
			download_image: "Herunterladen",
			share_image: "Teilen",
			export_failed: "Das Bild konnte nicht exportiert werden",
			share_unavailable: "Das Teilen von Bildern wird in diesem Browser nicht unterstützt",
			patterns: {
				solid: "Durchgehend",
				hatch: "Schraffur",
				crosshatch: "Kreuzschraffur",
				dots: "Punkte",
				checker: "Schachbrett",
				waves: "Wellen",
				stripes: "Streifen",
				grid: "Raster",
				plus: "Plus",
				none: "Keine",
			},
			tools: {
				tools: "Werkzeuge",
				dimension: "Bemaßung",
				polygon: "Polygon",
				select: "Auswählen",
				text: "Text",
			},
			fill_color: "Füllfarbe",
			stroke: "Kontur",
			fill: "Füllung",
			font_size: "Schriftgröße",
			offset: "Versatz",
			tilt: "Neigung",
			continue_dimension: "Maß fortsetzen",
			text_placeholder: "Text",
			stroke_color: "Konturfarbe",
			stroke_width: "Konturbreite",
			marker_color: "Markerfarbe",
			text: "Text",
			pattern: "Muster",
			opacity: "Deckkraft",
		},
		controlling: {
			controlling: "Controlling",
			average_invoice_sum: "Durchschnittliche Rechnungssumme",
			incoming_invoices: "Eingangsrechnungen",
			invoice: "Rechnung",
			invoice_reminders: "Mahnungen",
			delivery_notes: "Lieferscheine",
			payment_files: "Zahlungsdateien",
			invoices: "Rechnungen",
			my_invoice_approvals: "Meine Prüfungen",
			offers: "Angebote",
			outgoing_invoices: "Ausgangsrechnungen",
			total_invoice_sum: "Gesamte Rechnungssumme",
		},
		address: {
			address: "Adresse",
			city: "Stadt",
			country: "Land",
			house_number: "Hausnummer",
			street: "Straße",
			zip_code: "PLZ",
			coordinates_not_found:
				"Diese Adresse konnte nicht gefunden werden. Prüfen Sie Straße, Postleitzahl und Ort.",
		},
		auth: {
			enter_your_pin: "PIN eingeben",
			invalid_badge_id: "Ungültige Ausweis-ID",
			invalid_pin: "Ungültige PIN",
			loading_session: "Sitzung wird geladen...",
			confirm_password: "Passwort bestätigen",
			forgot_password: "Passwort vergessen?",
			new_password: "Neues Passwort",
			api_key: "API-Schlüssel",
			username: "Benutzername",
			password: "Passwort",
			remember_me: "Angemeldet bleiben",
			reset_password: "Passwort zurücksetzen",
			get_password_reset_link: "Link zum Zurücksetzen des Passworts anfordern",
			password_reset_link_sent: "Link zum Zurücksetzen des Passworts gesendet",
			signin: "Anmelden",
			signout: "Abmelden",
			signup: "Registrieren",
			signin_with_qr: "Mit QR-Code anmelden",
			unauthorized: "Nicht berechtigt",
			updated_password: "Passwort aktualisiert",
			account: "Konto",
		},
		chats: {
			chat: "Chat",
			chats: "Chats",
			message: "Nachricht",
			messages: "Nachrichten",
			send_message: "Nachricht senden",
			write_a_message: "Schreibe eine Nachricht",
		},
		cms: {
			cms: "CMS",
		},
		confirmation: {
			confirm_discard: "Möchten Sie Ihre Änderungen wirklich verwerfen?",
			confirm_deactivation:
				"Möchten Sie dieses Element wirklich deaktivieren? Diese Aktion kann rückgängig gemacht werden.",
			confirm_deletion:
				"Möchten Sie dieses Element wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
		},
		images: {
			images: "Bilder",
			image: "Bild",
			not_found: "Dieses Bild ist nicht mehr verfügbar.",
			take_photo: "Foto aufnehmen",
		},
		contacts: {
			vat_id: "USt.-IdNr.",
			tax_number: "Steuernummer",
			bank_accounts: {
				bank_accounts: "Bankverbindungen",
				add: "Bankverbindung hinzufügen",
				edit: "Bankverbindung bearbeiten",
				bank_name: "Bank",
				is_default: "Standard",
				source: "Herkunft",
				sources: {
					invoice: "Aus einer Rechnung",
					manual: "Erfasst",
				},
				delete_confirm_message: "Möchten Sie diese Bankverbindung wirklich entfernen?",
				duplicate_iban: "Der Kontakt hat diese IBAN bereits.",
			},
			related_contact: "Verknüpfter Kontakt",
			add_contact: "Kontakt hinzufügen",
			add_member: "Mitglied hinzufügen",
			contact: "Kontakt",
			contacts: "Kontakte",
			edit_contact: "Kontakt bearbeiten",
			edit_contact_project_override: "Für Projekt bearbeiten",
			edit_member: "Mitglied bearbeiten",
			edit_member_project_override: "Für Projekt bearbeiten",
			fields: {
				name: "Name",
			},
			members: "Mitglieder",
			member_types: "Mitgliedstypen",
			member_authorizations: "Mitgliedsberechtigungen",
			delete_contact_member: "Ansprechpartner löschen",
			delete_contact_member_confirm_message:
				"Möchten Sie dieses Kontaktmitglied wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			superior_contact: "Übergeordneter Kontakt",
			contact_types: "Kontakttypen",
			select_contact: "Kontakt auswählen",
			not_found: "Dieser Kontakt existiert nicht mehr.",
			member_not_found:
				"Einer der ausgewählten Ansprechpartner gehört nicht mehr zu diesem Kontakt.",
		},
		dates: {
			weekdays: "Wochentage",
			all_day: "Ganztägig",
			calendar: "Kalender",
			calendarweek: "Kalenderwoche",
			calendarweek_abbr: "KW",
			current_month: "Aktueller Monat",
			today: "Heute",
			date: "Datum",
			dates: "Termine",
			time_suffix: "Uhr",
			hours_abbr: "Std.",
			minutes_abbr: "Min.",
			on_the_same_day_at: "Am selben Tag um",
			on_the_previous_workday_at: "Am vorherigen Werktag um",
			time: "Uhrzeit",
			start_time: "Startzeit",
			end_time: "Endzeit",
			friday: "Freitag",
			monday: "Montag",
			saturday: "Samstag",
			select_date: "Datum auswählen",
			select_time: "Uhrzeit auswählen",
			select_value: "Wert auswählen",
			sunday: "Sonntag",
			thursday: "Donnerstag",
			tuesday: "Dienstag",
			wednesday: "Mittwoch",
			start_date: "Startdatum",
			end_date: "Enddatum",
			day: "Tag",
			days: "Tage",
			week: "Woche",
			weeks: "Wochen",
			month: "Monat",
			months: "Monate",
			quarter: "Quartal",
			quarters: "Quartale",
			year: "Jahr",
			years: "Jahre",
			end_date_cant_be_before_start_date: "Enddatum kann nicht vor dem Startdatum liegen",
		},
		personio: {
			open_personio_to_update: "In Personio öffnen, um zu aktualisieren",
			absence_categories: {
				paid_vacation: "Bezahlter Urlaub",
				unpaid_vacation: "Unbezahlter Urlaub",
				sick_leave: "Krankheit",
				parental_leave: "Elternzeit",
				special_leave: "Sonderurlaub",
				offsite_work: "Auswärtstätigkeit",
				azk_freizeitausgleich: "AZK Freizeitausgleich",
				other: "Sonstiges",
			},
			status: {
				requested: "Angefragt",
				approved: "Genehmigt",
				denied: "Abgelehnt",
				canceled: "Storniert",
				scheduled: "Geplant",
				taken: "Genommen",
				pending: "Ausstehend",
				rejected: "Abgelehnt",
			},
		},
		disclosure: {
			collapse: "Einklappen",
			expand: "Ausklappen",
		},
		documents: {
			acknowledgement_interval: "Bestätigungsintervall",
			acknowledgement_interval_months_1: "Monatlich",
			acknowledgement_interval_months_3: "Alle 3 Monate",
			acknowledgement_interval_months_6: "Alle 6 Monate",
			acknowledgement_interval_months_12: "Jährlich",
			acknowledgement_interval_months_24: "Alle 2 Jahre",
			add_documents: "Dokumente hinzufügen",
			document: "Dokument",
			documents: "Dokumente",
			edit_document: "Dokument bearbeiten",
		},
		file_upload: {
			delete_file_confirm_message:
				"Möchten Sie diese Datei wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Dies betrifft auch alle Verweise auf diese Datei in anderen Instanzen.",
			drop_files_here: "Dateien hier ablegen",
			drop_files_to_sort: "Dateien ablegen, automatisch einsortieren",
			file_upload: "Datei-Upload",
			files_uploaded_successfully: "Dateien erfolgreich hochgeladen",
			n_files_could_not_be_sorted: "{count} Dateien konnten nicht einsortiert werden",
			n_files_sorted: "{count} Dateien einsortiert",
			n_files_uploading: "{count} Dateien werden hochgeladen...",
			new_files: "Neue Dateien",
			open_inbox: "Posteingang öffnen",
			show_details: "Details anzeigen",
			previous_files: "Bisherige Dateien",
			release_to_drop: "Zum Ablegen loslassen",
			select_files_or_drop_here: "Dateien auswählen oder hier ablegen",
			sorting_n_files: "{count} Dateien werden einsortiert...",
			unlink_file_confirm_message:
				"Möchten Sie die Verknüpfung zu dieser Datei wirklich aufheben? Sie wird nur aus dieser Liste entfernt; die Datei selbst bleibt überall dort verfügbar, wo sie sonst noch verknüpft ist.",
			upload: "Hochladen",
			upload_failed: "Upload fehlgeschlagen",
			upload_files: "Dateien hochladen",
			upload_image: "Bild hochladen",
			upload_logo: "Logo hochladen",
			uploaded: "Hochgeladen",
			uploading: "Wird hochgeladen...",
		},
		files: {
			inbox: "Datei-Posteingang",
			inbox_collections: {
				outgoingInvoiceFiles: "Rechnung",
				projectDocumentFiles: "Projektdokumente",
				protocolFiles: "Protokoll",
				serviceCalculationFiles: "Kalkulation",
				ticketFiles: "Ticket",
			},
			batch_overview: "Dateizuordnung",
			batch_overview_empty: "Zu dieser Ablage liegt nichts mehr vor.",
			outcome: "Ergebnis",
			outcome_linked: "Einsortiert",
			outcome_pending: "Wird einsortiert",
			outcome_unplaced: "Nicht einsortiert",
			outcome_unknown_record: "Der Datensatz ist nicht mehr verfügbar",
			inbox_dropped_at: "Abgelegt am",
			inbox_dropped_by: "Abgelegt von",
			inbox_failed: "Fehlgeschlagen",
			inbox_file_it: "{file} einsortieren",
			inbox_file_it_action: "Einsortieren",
			inbox_file_it_into: "Einsortieren in",
			inbox_no_active_tickets: "Dieses Projekt hat keine aktiven Tickets.",
			inbox_no_protocols: "Dieses Projekt hat keine Protokolle.",
			inbox_pick_destination: "Ziel wählen",
			inbox_pick_project_first: "Wählen Sie zuerst ein Projekt aus, um einen Datensatz zu wählen.",
			inbox_records_failed: "Die Liste konnte nicht geladen werden.",
			inbox_reason: "Warum sie hier liegt",
			inbox_record: "Datensatz",
			inbox_suggestions: "Vorschläge",
			import_file: "Datei importieren",
			file: "Datei",
			files: "Dateien",
			no_files_available: "Keine Dateien verfügbar",
			open_file: "Datei öffnen",
			include_all: "Alle einschließen",
			include_container_only: "Nur Container einschließen",
			drop_files_here: "Dateien hier ablegen",
			file_name: "Dateiname",
			file_size: "Dateigröße",
			dimensions: "Abmessungen",
			full_path: "Vollständiger Pfad",
			folder_name: "Ordnername",
			folder: "Ordner",
			folders: "Ordner",
			folder_size: "Ordnergröße",
			signed_url: "Signierte URL",
			n_files_selected: "{count} Dateien ausgewählt",
			focused_item: "Fokussiertes Element: {name}",
			total_files: "Dateien gesamt: {count}",
			cannot_move_files: "Sie dürfen diese Dateien nicht verschieben.",
			batch_delete_refused:
				"Es wurde nichts gelöscht. Diese Dateien dürfen Sie nicht ändern: {files}",
			batch_move_refused:
				"Es wurde nichts verschoben. Diese Dateien dürfen Sie nicht ändern: {files}",
			batch_move_failed:
				"Der Ordner enthält bereits eine Datei gleichen Namens, deshalb sind diese liegen geblieben: {files}",
			delete_file: "Datei löschen",
			delete_n_files: "{count} Dateien löschen",
			download_n_files: "{count} Dateien herunterladen",
			download: "Herunterladen",
			download_all: "Alle herunterladen",
			delete_file_confirm_message:
				"Möchten Sie diese Datei wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			delete_files_confirm_message:
				"Möchten Sie diese Dateien wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			move_all_selected_files_to_folder_confirm_message:
				"Möchten Sie wirklich alle ausgewählten Dateien in diesen Ordner verschieben? Klicken Sie auf 'Nein', um nur die tatsächlich gezogene Datei zu verschieben.",
			move: "Dateien verschieben",
			dont_move: "Dateien nicht verschieben",
			create_folder: "Ordner erstellen",
			moving_files: "Dateien werden verschoben...",
			moved_files_successfully: "Dateien erfolgreich verschoben",
			error_moving_files: "Fehler beim Verschieben der Dateien",
			processing_file: "Datei wird verarbeitet...",
			failed_processing_file: "Verarbeitung der Datei fehlgeschlagen...",
			successfully_processed_file: "Datei erfolgreich verarbeitet.",
		},
		general: {
			converting: "Wird konvertiert...",
			home: "Home",
			error: "Fehler",
			show_all: "Alle anzeigen",
			total: "Gesamt",
			approved_by: "Genehmigt von",
			approved_at: "Genehmigt am",
			rejected_by: "Abgelehnt von",
			rejected_at: "Abgelehnt am",
			update: "Aktualisieren",
			order_by: "Sortieren nach",
			reject: "Ablehnen",
			approve: "Genehmigen",
			all: "Alle",
			start: "Start",
			end: "Ende",
			standard: "Standard",
			label: "Bezeichnung",
			retry: "Erneut versuchen",
			canceled: "Storniert",
			number: "Nummer",
			select_columns: "Spalten auswählen",
			identifier: "Kennung",
			quantity: "Menge",
			scope: "Bereich",
			scope_user: "Nur ich",
			scope_global: "Global",
			deleting: "Wird gelöscht...",
			updating: "Wird aktualisiert...",
			successfully_deleted: "Erfolgreich gelöscht",
			successfully_updated: "Erfolgreich aktualisiert",
			deleting_failed: "Löschen fehlgeschlagen",
			updating_failed: "Aktualisieren fehlgeschlagen",
			is_required: "Ist erforderlich",
			not_required: "Nicht erforderlich",
			source: "Quelle",
			progress: "Fortschritt",
			join: "Beitreten",
			global: "Global",
			references: "Referenzen",
			menu: "Menü",
			link: "Link",
			duplicate: "Duplizieren",
			summary: "Zusammenfassung",
			fill_in_required_fields: "Bitte füllen Sie alle erforderlichen Felder aus",
			description: "Beschreibung",
			copy_link: "Link kopieren",
			copied_link: "Link in die Zwischenablage kopiert",
			copied_to_clipboard: "In die Zwischenablage kopiert",
			invalid_iban: "Ungültige IBAN",
			no_access: "Sie haben keinen Zugriff auf diese Ressource.",
			checking_permissions: "Berechtigungen werden geprüft...",
			permissions_unavailable:
				"Ihre Berechtigungen konnten nicht geprüft werden. Bitte erneut versuchen.",
			forbidden: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
			internal_error: "Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
			request_failed: "Die Anfrage konnte nicht abgeschlossen werden.",
			content_not_loadable: "Dieser Inhalt konnte nicht geladen werden.",
			active: "Aktiv",
			text: "Text",
			add: "Hinzufügen",
			advanced: "Erweitert",
			back: "Zurück",
			cancel: "Abbrechen",
			caution: "Achtung",
			close: "Schließen",
			confirm: "Bestätigen",
			continue: "Weiter",
			other: "Sonstiges",
			create: "Erstellen",
			delete: "Löschen",
			deleted_successfully: "Erfolgreich gelöscht",
			details: "Details",
			dismiss: "Verwerfen",
			dismiss_unsaved_changes:
				"Möchten Sie die ungespeicherten Änderungen wirklich verwerfen? Diese Aktion kann nicht rückgängig gemacht werden.",
			done: "Fertig",
			edit: "Bearbeiten",
			rename: "Umbenennen",
			enter_value: "Wert eingeben",
			export: "Exportieren",
			export_as_csv: "Als CSV exportieren",
			extended: "Erweitert",
			filter: "Filter",
			general: "Allgemein",
			name: "Name",
			history: "Verlauf",
			inactive: "Inaktiv",
			information: "Information",
			loading: "Wird geladen",
			no: "Nein",
			no_data_available: "Keine Daten verfügbar",
			not_found: "Nicht gefunden",
			notes: "Notizen",
			open: "Öffnen",
			optional: "Optional",
			overview: "Übersicht",
			pending: "Ausstehend",
			approved: "Genehmigt",
			refresh: "Aktualisieren",
			remove: "Entfernen",
			reset: "Zurücksetzen",
			save: "Speichern",
			saved: "Gespeichert",
			search: "Suche",
			select: "Bitte auswählen",
			select_all: "Alle auswählen",
			deselect_all: "Alle abwählen",
			select_existing_files: "Vorhandene Dateien auswählen",
			selected: "Ausgewählt",
			send: "Senden",
			settings: "Einstellungen",
			something_went_wrong: "Etwas ist schief gelaufen",
			state: "Status",
			submit: "Absenden",
			value: "Wert",
			yes: "Ja",
			unauthorized: "Nicht berechtigt",
			too_many_requests:
				"Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
			unknown: "Unbekannt",
			order_direction: "Sortierrichtung",
			order_direction_asc: "Aufsteigend",
			order_direction_desc: "Absteigend",
			preview: "Vorschau",
			pdf_preview: "PDF-Vorschau",
			download: "Herunterladen",
			i_do_understand_the_consequences: "Ich verstehe die Konsequenzen",
			danger_zone: "Gefahrenzone",
			i_understand: "Ich verstehe",
			type: "Typ",
			last_updated: "Zuletzt aktualisiert",
			options: "Optionen",
			just_save: "Nur speichern",
			no_menu_items_available: "Keine Menüeinträge verfügbar",
		},
		general_fields: {
			created_at: "Erstellt am",
			created_by: "Erstellt von",
			deleted_at: "Gelöscht am",
			deleted_by: "Gelöscht von",
			id: "ID",
			state: "Status",
			updated_at: "Aktualisiert am",
			updated_by: "Aktualisiert von",
		},
		greetings: {
			hello: "Hallo",
			good_morning: "Guten Morgen",
			good_afternoon: "Guten Tag",
			good_evening: "Guten Abend",
			good_night: "Gute Nacht",
		},
		hints: {
			hint: "Hinweis",
			please_fill_out_all_fields: "Bitte füllen Sie alle Felder aus",
			you_can_change_this_at_any_time: "Sie können dies jederzeit ändern",
		},
		home: {
			groups: {
				general: "Allgemein",
				commercial: "Kaufmännisch",
				team: "Team",
				personal: "Mein Bereich",
				favorites: "Favoriten",
			},
			/**
			 * The one action a tile's long-press menu offers, worded for the state the tile is in.
			 */
			add_to_favorites: "Zu Favoriten hinzufügen",
			remove_from_favorites: "Aus Favoriten entfernen",
			descriptions: {
				incoming_invoice_approvals: "Eingangsrechnungen zur Prüfung",
				returns: "Rücklieferungen von Projekten",
				planning: "Tagesplanung der Kolonnen",
				projects: "Projekte",
				protocols: "Besprechungs- und Gesprächsprotokolle",
				vehicles: "Fuhrpark und Fahrzeugdaten",
				wiki: "Wissensdatenbank des Unternehmens",
				invoices: "Ausgangsrechnungen",
				controlling: "Aufmaße und Abrechnung",
				calculations: "Angebote und Kalkulationen",
				services: "Leistungskatalog",
				contacts: "Kunden, Lieferanten und Ansprechpartner",
				partners: "Partnerfirmen und Buchungen",
				bookings: "Stundenzettel einreichen und prüfen",
				submit_bookings: "Stunden Deiner Kolonnen bei Partnern",
				review_bookings: "Stundenzettel für Deine Projekte",
				users: "Mitarbeiterverzeichnis",
				absence_calendar: "Abwesenheitskalender",
				attendance_approvals: "Arbeitszeiten zur Freigabe",
				absence_approvals: "Abwesenheiten zur Freigabe",
				attendances: "Deine Arbeitszeiten",
				my_absences: "Dein Urlaub und Deine Abwesenheiten",
				substitutions: "Vertretungspläne",
				measurements: "Aufmaße nach Projektleiter",
				controlling_invoices: "Alle Rechnungen nach Status",
				articles: "Artikel und Lagerbestand",
				warehouse_zones: "Lagerzonen und Lagerplätze",
				load_carriers: "Paletten, Gitterboxen und Körbe",
				transport_orders: "Offene Transporte von Ladungsträgern",
				put_away: "Einlagerung von Rückläufern",
				orders: "Materialbestellungen",
				my_orders: "Bestellungen für Deine Projekte",
				article_groups: "Artikelgruppen",
				article_product_types: "Produktarten",
				tour_waves: "Liefertouren und Bestellschluss",
				order_templates: "Bestellvorlagen",
				picking: "Kommissionierung offener Bestellungen",
				settings: "Profil, Sprache und Abmelden",
			},
		},
		incoming_invoices: {
			add_cost_allocation_row: "Kostenstelle hinzufügen",
			allocated: "Verteilt",
			allocated_by: "Aufgeteilt durch",
			allocation_source: {
				manual: "Manuell",
				suggested: "KI-Vorschlag",
			},
			amount: "Betrag",
			amounts: "Beträge",
			approval_comment: "Kommentar",
			approval_comment_placeholder: "Begründung",
			decision: {
				review: "Prüfen",
				title: "Rechnung prüfen",
				accept: "Akzeptieren",
				reject: "Ablehnen",
				cost_allocation: "Kostenaufteilung",
				reduce: "Kürzen",
				reduce_hint:
					"Weniger zahlen, als die Rechnung verlangt. Die Kostenaufteilung wird mitgekürzt.",
				printed_net_amount: "Berechneter Nettobetrag",
				reduced_net_amount: "Gekürzter Nettobetrag",
				reduction_reason: "Grund der Kürzung",
				reduction_reason_required: "Eine Kürzung braucht einen Grund",
				reduced_amount_required: "Geben Sie einen gekürzten Nettobetrag über null ein",
				reduction_too_high: "Der gekürzte Betrag muss unter dem berechneten Nettobetrag liegen",
				comment: "Notiz (optional)",
				comment_placeholder: "z. B. mit Lieferschein abgeglichen",
				rejection_reason: "Grund der Ablehnung",
				submit_accept: "Rechnung akzeptieren",
				submit_reject: "Rechnung ablehnen",
				skip_chain_title: "Vor der Kette entscheiden?",
				skip_chain_message:
					"{count} Prüfer vor Ihnen haben noch nicht entschieden. Wenn Sie jetzt entscheiden, werden sie übersprungen. Fortfahren?",
				your_turn: "Sie sind dran",
				waiting_for: "Wartet auf {name}",
				waiting: "Wartet",
				chain_position: "Reihenfolge",
				reduced_from: "Gekürzt von {from} auf {to}",
				reduced_by: "Gekürzt von",
				reductions: "Kürzungen",
				allocation_must_match: "Die Kostenaufteilung muss {amount} ergeben",
				no_cost_centers: "Die Organisation führt keine Kostenstellen zum Aufteilen.",
				add_cost_center: "Kostenstelle hinzufügen",
				history: "Entscheidungen",
				not_your_turn: "Sie sind in der Prüfkette noch nicht an der Reihe.",
				cannot_take_back: "Nach Ihnen wurde in der Kette bereits entschieden.",
				handover_not_entitled:
					"Nur ein Standard-Prüfer oder der zuletzt beauftragte Prüfer kann die Rechnung weitergeben.",
				handover_sole_approver:
					"Die Rechnung hat eine alleinige Freigabe. Nehmen Sie diese Übertragung zurück, bevor Sie die Prüfung erneut übertragen.",
				share: "Anteil",
				amount: "Betrag",
				allocation_sum_mismatch: "Die Kostenaufteilung muss den Nettobetrag ergeben",
				unknown_cost_center: "Eine Kostenstelle der Aufteilung ist nicht aktiv",
			},
			approval_state: {
				approved: "Freigegeben",
				pending: "Ausstehend",
				rejected: "Abgelehnt",
				skipped: "Übersprungen",
				state: "Status",
			},
			approvals_filter: {
				decided: "Erledigt",
				pending: "Offen",
			},
			approve: "Freigeben",
			approver: "Prüfer",
			approver_set: "Gilt für",
			approvers_need_read_rule:
				"Nur Mitglieder, deren Rolle eingehende Rechnungen sehen darf, können prüfen.",
			approvers_required: "Die Organisation braucht mindestens einen Standard-Prüfer",
			awaiting_approval: "Freigabe ausstehend",
			bic: "BIC",
			by_state: "Nach Status",
			calendar_week: "KW {week}",
			check_groups: {
				arithmetic: "Rechnerische Prüfung",
				formal: "Formale Prüfung",
			},
			check_hints: {
				difference: "Abweichung {amount}",
				duplicate_of: "Dublette von {number}",
				incomplete: "Zu wenig zum Vergleichen",
				invalid_iban: "IBAN fehlerhaft gelesen",
				no_cost_centers: "Keine Kostenstellen",
				no_positions: "Keine Positionen",
				same_document_as: "Gleiches Dokument wie {number}",
				new_iban: "Neue IBAN",
				suspected_fraud: "Betrugsverdacht",
				unknown_partner_iban: "Dem Partner unbekannt",
			},
			checks: {
				cost_allocation_complete: "Kostenverteilung vollständig",
				gross_matches_net_plus_vat: "Brutto = Netto + USt.",
				iban_known: "IBAN beim Lieferanten bekannt",
				invoice_date_present: "Rechnungsdatum vorhanden",
				issuer_assigned: "Lieferant zugeordnet",
				no_duplicate: "Keine Dublette",
				number_present: "Rechnungsnummer vorhanden",
				positions_match_net: "Summe der Positionen = Netto",
				tax_id_known: "Steuernummer/USt.-IdNr. bekannt",
			},
			contact: "Kontakt",
			cost_allocation: "Kostenverteilung",
			cost_allocation_must_add_up: "Die Beträge müssen genau den Nettobetrag ergeben",
			cost_allocation_remaining: "Noch zu verteilen: {amount}",
			currency: "Währung",
			decided_at: "Geprüft am",
			default_approvers: "Standard-Prüfer",
			details: "Details",
			dismiss_duplicate: "Keine Dublette",
			document: "Dokument",
			due_date: "Fälligkeit",
			due_in_7_days: "Fällig in 7 Tagen",
			due_per_week: "Fälligkeiten pro Woche",
			duplicate_description:
				"Sie wiederholt eine frühere Rechnung und wird nirgends gezählt, bis sie zusammengeführt oder als keine Dublette markiert ist.",
			duplicate_title: "Dublette von {number}",
			edit_cost_allocation: "Kostenverteilung bearbeiten",
			edit_default_approvers: "Standard-Prüfer: {name}",
			edit_invoice: "Rechnung bearbeiten",
			email_arrived_at: "E-Mail eingegangen",
			events: {
				approval_requested: "hat die Prüfung angefordert",
				approval_withdrawn: "hat eine Übertragung zurückgenommen",
				approved: "hat die Rechnung freigegeben",
				checked: "hat die Rechnung geprüft",
				cost_allocation_changed: "hat die Kostenverteilung geändert",
				cost_allocation_cleared: "hat die Kostenverteilung entfernt",
				cost_allocation_suggested: "hat eine Kostenverteilung vorgeschlagen",
				decision_taken_back: "hat eine Entscheidung zurückgenommen",
				duplicate_detected: "hat eine Dublette erkannt",
				duplicate_dismissed: "hat die Dublette aufgehoben",
				duplicate_merged: "hat eine Dublette mit dieser Rechnung zusammengeführt",
				field_changed: "hat Felder geändert",
				merged_into: "hat diese Rechnung mit dem Original zusammengeführt",
				open_other_invoice: "Andere Rechnung öffnen",
				read: "hat die Rechnung ausgelesen",
				read_failed: "konnte die Rechnung nicht auslesen",
				received: "hat die Rechnung per E-Mail erhalten",
				rejected: "hat die Rechnung abgelehnt",
				reminder_received: "hat eine Mahnung erhalten",
				payment_exported: "hat die Zahlung exportiert",
				payment_reverted: "hat die Zahlung zurückgenommen",
				iban_confirmed: "hat die IBAN für den Lieferanten bestätigt",
				approval_skipped: "hat eine Prüfung übersprungen",
				amount_reduced: "hat den Betrag gekürzt",
				reduction_lifted: "hat die Kürzung aufgehoben",
				delivery_note_linked: "hat einen Lieferschein zugeordnet",
				delivery_note_unlinked: "hat einen Lieferschein entfernt",
				approvals_reset: "hat die Prüfung zurückgesetzt",
				state_changed: "hat den Status geändert",
				system: "System",
			},
			extraction_error: "Warum sie nicht gelesen werden konnte",
			extraction_failed: "Nicht lesbar",
			failed_checks_description:
				"{count} Prüfpunkt(e) dieser Rechnung sind fehlgeschlagen. Sie können sie trotzdem freigeben.",
			failed_checks_title: "Nicht alle Prüfpunkte bestanden",
			failed_checks_count: "{count} Prüfpunkt(e) fehlgeschlagen",
			approvers_title: "Prüfer",
			falls_back_to_organization_approvers: "Die Prüfer der Organisation",
			falls_back_to_owner: "Der Inhaber der Organisation",
			gross_amount: "Brutto",
			gross_hint: "brutto",
			handover: {
				asked_by: "Angefragt von",
				default_approver: "Standard-Prüfer",
				hand_over: "Prüfung übertragen",
				handed_over: "Übertragen",
				not_required: "Nicht mehr erforderlich",
				sole: "Alleinige Freigabe",
				sole_description:
					"Nur die Freigabe dieser Person zählt; alle anderen Prüfungen der Rechnung werden entfernt. Wird die Übertragung zurückgenommen, prüfen wieder die Standard-Prüfer.",
				sole_label: "Alleinige Freigabe",
				withdraw: "Übertragung zurücknehmen",
			},
			iban: "IBAN",
			incoming_invoice: "Eingangsrechnung",
			invoice: "Rechnung",
			invoice_date: "Rechnungsdatum",
			invoice_n: "Rechnung {number}",
			issuer: "Rechnungssteller",
			issuer_address: "Anschrift",
			issuer_email: "E-Mail",
			issuer_name: "Firma",
			issuer_phone: "Telefon",
			kind: {
				credit_note: "Gutschrift",
				final_invoice: "Schlussrechnung",
				invoice: "Rechnung",
				partial_invoice: "Abschlagsrechnung",
			},
			kind_label: "Art",
			mailboxes: "Postfächer",
			merge_duplicate: "Mit Original zusammenführen",
			merge_duplicate_confirm_message:
				"Dublette mit dem Original zusammenführen? Dokument und Notizen wandern dorthin, die Dublette verschwindet aus allen Listen.",
			n_invoices: "{count} Rechnungen",
			net_amount: "Netto",
			net_hint: "netto",
			no_document: "Unter dieser Rechnung ist kein Dokument abgelegt",
			not_allocated: "Nicht verteilt",
			not_allocated_yet: "Noch nicht aufgeteilt",
			not_found: "Diese Rechnung existiert nicht mehr.",
			number: "Rechnungsnummer",
			open: "Offen",
			open_invoice: "Rechnung öffnen",
			organization_approvers: "Organisation (alle übrigen Rechnungen)",
			overdue: "Überfällig",
			partner: "Partner",
			partner_report_summary: "Report für KW {week}, {total}",
			payment: "Zahlung",
			position_description: "Bezeichnung",
			position_number: "Pos.",
			position_total: "Gesamt",
			positions: "Positionen",
			quantity: "Menge",
			received_per_month: "Eingang pro Monat",
			received_at: "Empfangen",
			received_at_hint:
				"Der Eingang der E-Mail, verschoben in die Geschäftszeiten des Workspace: Eine E-Mail, die außerhalb eingeht, gilt mit der nächsten Öffnung als empfangen.",
			recipient: "Rechnungsempfänger",
			reject: "Ablehnen",
			rejection_comment_required: "Bitte begründen Sie die Ablehnung",
			e_invoice_format: {
				zugferd: "E-Rechnung (ZUGFeRD)",
				xrechnung: "E-Rechnung (XRechnung)",
			},
			delete_invoice: "Rechnung löschen",
			delete_invoice_description:
				"Diese Rechnung mit Positionen, Prüfungen, Prüfpunkten, Kostenverteilung, Notizen und Verlauf dauerhaft löschen. Das angehängte Dokument bleibt bei seiner E-Mail. Dies kann nicht rückgängig gemacht werden.",
			delete_invoice_confirm_message:
				"Möchten Sie diese Rechnung wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
			delete_invoice_type_to_confirm: 'Geben Sie "{phrase}" zur Bestätigung ein',
			delete_paid_refused:
				"Eine bezahlte Rechnung kann nicht gelöscht werden. Nehmen Sie zuerst die Zahlung zurück.",
			reset: {
				title: "Prüfung zurücksetzen",
				description:
					"Alle Freigaben entfernen, die Standard-Prüfer neu anfragen und die Kürzung aufheben. Kostenaufteilung und Entscheidungsverlauf bleiben erhalten. Eine freigegebene Rechnung lässt sich nur nach einem Zurücksetzen ändern.",
				button: "Prüfung zurücksetzen",
				confirm_message:
					"Die Prüfung dieser Rechnung zurücksetzen? Alle bisherigen Freigaben werden verworfen.",
				locked:
					"Eine freigegebene Rechnung kann nicht mehr geändert werden. Setzen Sie zuerst ihre Prüfung zurück.",
				paid_refused:
					"Eine bezahlte Rechnung kann nicht zurückgesetzt werden. Nehmen Sie zuerst die Zahlung zurück.",
				duplicate_refused:
					"Eine Dublette wird zusammengeführt oder als keine markiert, nicht zurückgesetzt.",
				done: "Prüfung zurückgesetzt",
			},
			iban_check: {
				new_title: "Neue IBAN: {iban}",
				new_description:
					"Für den Lieferanten ist noch keine Bankverbindung hinterlegt. Bestätigen Sie diese IBAN über einen Ihnen bekannten Weg beim Lieferanten — nicht über die Kontaktdaten der Rechnung — bevor Sie freigeben.",
				fraud_title: "Betrugsverdacht: unbekannte IBAN {iban}",
				fraud_description:
					"Der Lieferant ist mit anderen Bankverbindungen hinterlegt. Gefälschte Rechnungen bitten um Zahlung auf ein neues Konto — bestätigen Sie es über einen Ihnen bekannten Weg beim Lieferanten, bevor Sie freigeben, und lehnen Sie die Rechnung im Zweifel ab.",
				confirm: "IBAN bestätigen",
				confirm_message:
					"Diese IBAN zu den Bankverbindungen des Lieferanten hinzufügen? Nur tun, wenn der Lieferant sie bestätigt hat. Ihre Bestätigung wird festgehalten.",
				approval_blocked: "Bestätigen Sie die IBAN der Rechnung, bevor Sie sie freigeben.",
				not_an_approver: "Nur Prüfer dieser Rechnung können ihre IBAN bestätigen.",
				partner_title: "IBAN dem Partner unbekannt: {iban}",
				partner_description:
					"Keiner der Betriebe der Partnerorganisation führt diese IBAN. Bitten Sie den Partner, sie in den Bankdaten seines Betriebs zu hinterlegen, und prüfen Sie dann erneut — bis dahin kann die Rechnung nicht freigegeben werden.",
				recheck: "Erneut prüfen",
				no_valid_iban: "Die Rechnung enthält keine gültige IBAN zum Bestätigen.",
				no_contact: "Ordnen Sie die Rechnung einem Kontakt zu, bevor Sie ihre IBAN bestätigen.",
				partner_still_unknown: "Die Betriebe des Partners führen diese IBAN noch nicht.",
			},
			payments: {
				exported_at: "Exportiert",
				exported_by: "Exportiert von",
				invoices: "Bezahlte Rechnungen",
				export_payments: "Zahlungen exportieren",
				export_payments_count: "Zahlungen exportieren ({count})",
				export_payment_file: "Zahlungsdatei exportieren",
				export_hint:
					"Die Datei ist für StarMoney oder jede Banking-Software, die SEPA-Dateien importiert. Die Rechnungen werden beim Herunterladen als bezahlt markiert.",
				apply_skonto: "Offenes Skonto abziehen",
				apply_skonto_description:
					"Zieht bei jeder Rechnung, deren Skontofrist noch läuft, das Skonto ab.",
				format: "Format",
				format_09: "pain.001.001.09 — aktueller Standard",
				format_03: "pain.001.001.03 — ältere Banking-Software",
				execution_date: "Ausführungsdatum",
				transfer_count: "Überweisungen",
				invoice_count: "Rechnungen",
				total: "Summe",
				skonto_total: "Skonto",
				exported: "Zahlungsdatei exportiert, {count} Rechnung(en) als bezahlt markiert",
				not_payable: "Einige dieser Rechnungen können nicht bezahlt werden.",
				not_payable_title: "Nicht bezahlbar",
				not_paid: "Die Rechnung ist nicht bezahlt.",
				revert_payment: "Zahlung zurücknehmen",
				revert_payment_message:
					"Die Rechnung wird wieder auf freigegeben gesetzt und kann in einer späteren Datei bezahlt werden. Stellen Sie sicher, dass die Bank die Überweisung nicht ausgeführt hat.",
				payment_reverted: "Zahlung zurückgenommen",
				download_file: "Zahlungsdatei herunterladen",
				payable: "Bezahlbar",
				paid_amount: "Bezahlt",
				skonto_taken: "Abgezogenes Skonto",
				offsets: {
					offset: "Verrechnen",
					offsets: "Verrechnung",
					title: "{number} verrechnen",
					hint: "Offene Ausgangsrechnungen der Projekte, deren Auftraggeber {supplier} ist. Sie werden beim Export der Zahlungsdatei in der Reihenfolge, in der Sie sie wählen, von der Zahlung abgezogen, jede bis zu ihrem offenen Betrag. Die Beträge sind netto: Ausgangsrechnungen zwischen Baufirmen laufen im Reverse-Charge-Verfahren.",
					planned_hint:
						"Wird beim Export der Zahlungsdatei in dieser Reihenfolge von der Überweisung abgezogen.",
					none_planned:
						"{count} offene Ausgangsrechnung(en) an diesen Lieferanten — keine Verrechnung geplant",
					saved: "Verrechnung gespeichert",
					sum: "Summe (netto)",
					open_amount: "Offen (netto)",
					applied: "Verrechnet",
					not_reached: "Nicht erreicht",
					not_reached_hint:
						"Die Zahlung ist gedeckt, bevor diese Rechnung erreicht wird, sie würde also nichts verrechnen. Entfernen Sie sie.",
					used_elsewhere: "Bereits für {number} vorgesehen",
					no_candidates: "Keine offenen Ausgangsrechnungen an diesen Lieferanten",
					load_failed: "Die offenen Ausgangsrechnungen konnten nicht geladen werden.",
					apply: "Übernehmen",
					payment: "Zahlung",
					total: "Verrechnet",
					to_transfer: "Zu überweisen",
					transferred: "Überwiesen",
					paid_by_offset: "Keine Überweisung — durch Verrechnung bezahlt",
					less_offset: "Abzgl. Verrechnung",
					less_offsets: "Abzgl. Verrechnung {numbers}",
					settled_without_file:
						"Keine Zahlungsdatei nötig: {count} Rechnung(en) durch Verrechnung beglichen und als bezahlt markiert",
					offset_only: "Durch Verrechnung beglichen",
					no_file: "Keine Zahlungsdatei — alle Rechnungen dieses Laufs wurden verrechnet",
					closed:
						"Die Verrechnung einer bezahlten oder abgeschlossenen Rechnung lässt sich nicht mehr ändern.",
					not_available:
						"Eine gewählte Ausgangsrechnung ist nicht mehr offen oder nicht an diesen Lieferanten gestellt.",
					planned_elsewhere:
						"Die Ausgangsrechnung {number} ist bereits für eine andere Rechnung vorgesehen.",
				},
				reasons: {
					"not-approved": "Nicht freigegeben",
					"credit-note": "Gutschrift",
					"not-eur": "Nicht in Euro",
					"no-amount": "Kein Bruttobetrag",
					"no-creditor": "Kein Lieferant",
					"invalid-offset": "Eine Verrechnung passt nicht zu dieser Rechnung",
					"unconfirmed-iban": "IBAN nicht durch Prüfer bestätigt",
					"no-creditor-iban": "Keine gültige Lieferanten-IBAN",
					"no-paying-account": "Workspace ohne Bankverbindung",
				},
			},
			reminders: {
				link_invoice: "Rechnung zuordnen",
				link_invoice_hint:
					"Die Mahnung nennt die Rechnung {number}. Wählen Sie die Rechnung, an die sie erinnert, oder leeren Sie das Feld, um eine falsche Zuordnung zu lösen.",
				search_invoice: "Rechnungsnummer oder Lieferant suchen",
				amount_due: "Gefordert",
				due_fee: "Zahlbar bis {dueDate}, Gebühr {fee}",
				fee: "Gebühr",
				level: "Stufe",
				level_1: "1. Mahnung",
				level_2: "2. Mahnung",
				level_3: "Letzte Mahnung",
				reminder: "Mahnung",
				reminder_date: "Datum",
				reminders: "Mahnungen",
				summary: "vom {date}, zahlbar bis {dueDate}, Gebühr {fee}",
				unmatched: "Nicht zugeordnet",
			},
			delivery_notes: {
				delivery_note: "Lieferschein",
				delivery_notes: "Lieferscheine",
				number: "Lieferschein-Nr.",
				delivery_date: "Lieferdatum",
				order_reference: "Auftrag",
				title: "Lieferschein {number}",
				position_count: "{count} Positionen",
				link_invoice: "Rechnung zuordnen",
				link_invoice_hint:
					"Lieferschein {number}. Wählen Sie die Rechnung, die ihn abrechnet, oder leeren Sie das Feld, um eine falsche Zuordnung zu lösen.",
				link_delivery_note: "Lieferschein zuordnen",
				link_delivery_note_hint: "Lieferscheine, die noch keiner Rechnung zugeordnet sind.",
				select_delivery_note: "Lieferschein auswählen",
				unlink: "Zuordnung lösen",
				waiting: "Wartet auf Rechnung",
				not_received: "Noch nicht eingegangen",
				none: "Kein Lieferschein zugeordnet",
			},
			report_not_found: "Kein Partner-Report trägt diese Nummer",
			// "Report Number" is the company's own term for its partner reports, in German too.
			report_number: "Report Number",
			requested_at: "Angefragt am",
			review: "Prüfung",
			review_requested: {
				title: "Eingangsrechnung prüfen",
				received: "{invoice} wartet auf Ihre Prüfung.",
				handed_over: "{name} hat Ihnen {invoice} zur Prüfung übergeben.",
				turn: "{invoice} liegt jetzt bei Ihnen zur Prüfung.",
				returned: "{name} hat {invoice} angenommen – sie liegt wieder bei Ihnen zur Prüfung.",
				from_issuer: "von {issuer}",
				for_amount: "über {amount}",
			},
			review_decided: {
				approved_title: "Rechnung angenommen",
				rejected_title: "Rechnung abgelehnt",
				approved: "{name} hat {invoice} angenommen.",
				approved_with_comment: "{name} hat {invoice} angenommen: {comment}",
				rejected: "{name} hat {invoice} abgelehnt.",
				rejected_with_comment: "{name} hat {invoice} abgelehnt: {comment}",
				someone: "Ein Prüfer",
			},
			share: "Anteil",
			skonto_amount: "Skontobetrag",
			skonto_deadline: "Skonto bis",
			skonto_rate: "Skonto",
			skonto_summary: "{rate} bis {date}",
			source: "Herkunft",
			state: {
				approved: "Freigegeben",
				duplicate: "Dublette",
				merged: "Zusammengeführt",
				paid: "Bezahlt",
				received: "Eingegangen",
				rejected: "Abgelehnt",
			},
			supplier: "Lieferant",
			take_back_decision: "Entscheidung zurücknehmen",
			take_rest: "Rest übernehmen",
			tax_ids: "USt-IdNr. / Steuernr.",
			tax_number: "Steuernummer",
			top_suppliers: "Top-Lieferanten",
			unit: "Einheit",
			unit_price: "Einzelpreis",
			vat_amount: "USt.",
			vat_id: "USt.-IdNr.",
			vat_rate: "USt.-Satz",
		},
		invoices: {
			add_invoice: "Rechnung hinzufügen",
			all_invoices: "Alle Rechnungen",
			calculated_to: "Berechnet bis",
			creation_date: "Erstellungsdatum",
			delete_invoice_cofirm_message:
				"Möchten Sie diese Rechnung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			edit_invoice: "Rechnung bearbeiten",
			final_invoice: "Schlussrechnung",
			invoice: "Rechnung",
			invoices: "Rechnungen",
			note: "Notiz",
			number: "Rechnungsnummer",
			overdue: "Überfällig",
			paid: "Bezahlt",
			pending: "Ausstehend",
			progress_invoice: "Abschlagsrechnung",
			progress_invoice_number: "Laufende Nummer",
			single_invoice: "Einzelrechnung",
			state: "Status",
			sum_gross: "Summe (brutto)",
			sum_net: "Summe (netto)",
			type: "Typ",
			not_found: "Diese Rechnung existiert nicht mehr.",
		},
		legal: {
			imprint: "Impressum",
			privacy_policy: "Datenschutzerklärung",
			terms_and_conditions: "Allgemeine Geschäftsbedingungen",
			terms_of_service: "Nutzungsbedingungen",
			terms_of_use: "Nutzungsbedingungen",
			legal_information: "Rechtliche Informationen",
		},
		localization: {
			al: "Albanisch",
			changed_language: "Sprache geändert",
			de: "Deutsch",
			en: "Englisch",
			fr: "Französisch",
			language: "Sprache",
			pl: "Polnisch",
			ro: "Rumänisch",
			sk: "Slowakisch",
			suggest_better_translation: "Bessere Übersetzung vorschlagen",
			suggest_better_translation_description: `
				Bitte helfen Sie uns, die Übersetzung für diesen Text zu verbessern, indem Sie eine bessere Übersetzung vorschlagen.
				Wir schätzen Ihre Hilfe!
			`,
			current_translation: "Aktuelle Übersetzung",
			suggested_translation: "Vorgeschlagene Übersetzung",
			tr: "Türkisch",
		},
		mailboxes: {
			add_mailbox: "Postfach verbinden",
			attachments: "Anhänge",
			connected: "Verbunden",
			connection: "Verbindung",
			custom_preset: "Anderer Anbieter (manuell eingeben)",
			delete_mailbox_confirm_message:
				"Dieses Postfach trennen? Der Abruf stoppt und das Passwort wird gelöscht. Bereits gespeicherte E-Mails bleiben erhalten.",
			edit_mailbox: "Postfach bearbeiten",
			email_address: "E-Mail-Adresse",
			email_count: "E-Mails",
			emails: "E-Mails",
			emails_of: "E-Mails in {label}",
			errors: {
				duplicate: "Dieses Postfach ist für diesen Zweck bereits verbunden",
				host_refused: "Zu diesem Host baut der Server keine Verbindung auf",
				login_refused:
					"Der Mailserver hat die Anmeldung abgelehnt — Benutzername und Passwort prüfen",
				rate_limited: "Zu viele Verbindungsprüfungen — eine Minute warten und erneut versuchen",
				unreachable: "Der Mailserver ist nicht erreichbar",
			},
			every_n_minutes: "Alle {count} Minuten",
			folder: "Ordner",
			from: "Von",
			from_email: "Von (E-Mail)",
			health: "Status",
			health_state: {
				failing: "Fehlerhaft",
				needs_attention: "Aufmerksamkeit nötig",
				ok: "OK",
			},
			imap_host: "IMAP-Server",
			imap_port: "Port",
			imap_security: "Verschlüsselung",
			imap_username: "Benutzername",
			is_paused: "Pausiert",
			label: "Bezeichnung",
			last_error: "Letzter Fehler",
			mailbox: "Postfach",
			last_polled_at: "Zuletzt geprüft",
			last_succeeded_at: "Letzter Erfolg",
			mailboxes: "Postfächer",
			never: "Nie",
			no_attachments: "Keine Anhänge",
			no_emails_yet: "Noch keine E-Mails abgerufen",
			not_found: "Dieses Postfach existiert nicht mehr.",
			note: "Hinweis",
			outcome: {
				failed: "Fehlgeschlagen",
				skipped: "Übersprungen",
				stored: "Gespeichert",
			},
			password: "Passwort",
			password_unchanged_hint: "Leer lassen, um das aktuelle Passwort zu behalten",
			poll_enqueued: "Wird abgerufen — die Liste aktualisiert sich gleich",
			poll_now: "Jetzt abrufen",
			polling_interval: "Abrufintervall",
			preset: "Anbieter",
			processing: "Verarbeitung",
			processing_state: {
				completed: "Abgeschlossen",
				failed: "Fehlgeschlagen",
				queued: "In Warteschlange",
				skipped: "Übersprungen",
				started: "In Bearbeitung",
			},
			received_at: "Empfangen",
			security: {
				starttls: "STARTTLS (Port 143)",
				tls: "TLS (Port 993)",
			},
			show_emails: "E-Mails anzeigen",
			subject: "Betreff",
		},
		maps: {
			map: "Karte",
			maps: "Karten",
			open_google_maps: "Google Maps öffnen",
		},
		mentions: {
			type_to_find_member_or_project: "Tippen, um Mitglied oder Projekt zu finden",
		},
		misc: {
			scale: "Skalierung",
			command_view: "Befehlsansicht",
			cumulative: "Kumulativ",
			sum: "Summe",
			scan_qr_code: "QR-Code scannen",
			scan_barcode: "Barcode scannen",
			scanning_documents: "Dokumente werden gescannt...",
			vibration: "Vibration",
			selected_n_out_of_m: "{n}/{m} ausgewählt",
			clear_cache: "Cache leeren",
			monospaced: "Monospace",
			send_email: "E-Mail senden",
			no_email_available: "Keine E-Mail verfügbar",
			call: "Anrufen",
			share: "Teilen",
			area_type: "Flächentyp",
			go_to_top: "Nach oben",
			charts: {
				basis: "Basis",
				basisClosed: "Basis Geschlossen",
				basisOpen: "Basis Offen",
				bump: "Bump",
				bumpX: "Bump Horizontal",
				bumpY: "Bump Vertikal",
				linear: "Linear",
				linearClosed: "Linear Geschlossen",
				monotone: "Monoton",
				monotoneX: "Monoton Horizontal",
				monotoneY: "Monoton Vertikal",
				natural: "Natürlich",
				step: "Stufen",
				stepAfter: "Stufen Danach",
				stepBefore: "Stufen Davor",
			},
			misc: "Sonstiges",
			pagination: {
				items: "Elemente",
				next: "Weiter",
				of: "von",
				page: "Seite",
				previous: "Zurück",
			},
			position: "Position",
			stacked: "Gestapelt",
			add_line: "Zeile hinzufügen",
			add_block: "Block hinzufügen",
			regions: {
				region: "Region",
				bw: "Baden-Württemberg",
				by: "Bayern",
				be: "Berlin",
				bb: "Brandenburg",
				hb: "Bremen",
				he: "Hessen",
				hh: "Hamburg",
				mv: "Mecklenburg-Vorpommern",
				ni: "Niedersachsen",
				nw: "Nordrhein-Westfalen",
				rp: "Rheinland-Pfalz",
				sl: "Saarland",
				sn: "Sachsen",
				st: "Sachsen-Anhalt",
				sh: "Schleswig-Holstein",
				th: "Thüringen",
			},
		},
		navigation: {
			dashboard: "Dashboard",
			fleet: "Flotte",
			my_space: "Mein Bereich",
			partners: "Partner",
			planning: "Planung",
			projects: "Projekte",
			sidebar_layout: "Seitenleisten-Layout",
			topbar_layout: "Kopfleisten-Layout",
			layout: "Layout",
		},
		notes: {
			quick_note: "Schnellnotiz",
			add_note: "Notiz hinzufügen",
			answers: "Antworten",
			delete_confirmation_message:
				"Möchten Sie diese Notiz wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			edit_note: "Notiz bearbeiten",
			edited: "Bearbeitet",
			note: "Notiz",
			notes: "Notizen",
			note_is_empty: "Eine Notiz braucht entweder einen Kommentar oder mindestens eine Datei.",
			no_access: "Sie können die Notizen hier nicht sehen.",
			reply: "Antworten",
			unmark_as_reply: "Als Antwort entmarkieren",
			mentioned_you_title: "{name} hat Sie erwähnt",
			mentioned_you_message: "{name} hat Sie in einer Notiz zu {parent} erwähnt",
			kinds: {
				project: "Projekt",
				contact: "Kontakt",
				order: "Bestellung",
				partnership: "Partnerschaft",
				service: "Leistung",
				diary_entry: "Tagebucheintrag",
				protocol: "Protokoll",
				return_order: "Rückholung",
				calculation_item: "Kalkulationsposition",
				calculation: "Kalkulation",
				picking_round: "Kommissionierrunde",
				substitution_plan: "Vertretungsplan",
				assignment: "Einsatz",
				transfer_carrier: "Transportträger",
				user: "Benutzer",
				vehicle: "Fahrzeug",
				warehouse_zone: "Lagerzone",
				wiki_page: "Wiki-Seite",
				incoming_invoice: "Eingangsrechnung",
			},
			details: {
				crew: "Kolonne",
				zone: "Lagerzone",
				position: "Position",
			},
		},
		integrations: {
			internal: "Intern",
			external: "Extern",
			webfleet: "Webfleet",
			personio: "Personio",
			personio_sync_role: "Rolle für synchronisierte Personen",
			personio_sync_role_description:
				"Personen, die der Personio-Abgleich anlegt, starten mit dieser Rolle. Ohne Rolle verweigert der Abgleich.",
			webfleet_auto_integration: "Webfleet (Auto-Integration)",
			suite: "Suite",
			integrations: "Integrationen",
			integration: "Integration",
			integration_not_active: "Integration ist nicht aktiv",
			integration_is_active: "Integration ist aktiv",
			setup_integration: "Integration einrichten",
			deactivate_integration: "Integration deaktivieren",
			deactivate_integration_confirmation:
				"Möchten Sie diese Integration wirklich deaktivieren? Diese Aktion kann nicht rückgängig gemacht werden. Um die Integration zu reaktivieren, müssen Sie sie erneut einrichten.",
			dont_worry: "Keine Sorge",
			we_store_your_api_credentials_securely:
				"Ihre API-Zugangsdaten werden sicher verschlüsselt gespeichert und ausschließlich zur Authentifizierung von Anfragen an die Integration-API verwendet.",
			integrated_at: "Integriert am {date}",
			integration_type: "Integrationstyp",
			connected: "Verbunden",
			connect: "Verbinden",
			disconnect: "Trennen",
			not_connected: "Nicht verbunden",
			state: "Status",
			confirm_message_disconnect_integration: "Möchten Sie diese Integration wirklich trennen?",
			no_integrations_found: "Keine Integrationen gefunden",
			checking_active_integration: "Aktive Integration wird geprüft...",
			state_both: "Vollständig integriert",
			state_internal: "Interne Daten verfügbar",
			state_external: "Externe Daten verfügbar",
			synchronize_n_with_webfleet: "{count} Fahrzeuge mit Webfleet synchronisieren",
			send_user_credentials_to_me: "Benutzeranmeldedaten in Kopie an mich senden.",
			personio_no_active_integration: "Ihr Konto ist nicht mit Personio verbunden.",
			personio_sync: {
				title: "Mit Personio abgleichen",
				sync_n_people: "{count} Personen abgleichen",
				name: "Name",
				email: "E-Mail",
				status: "Status",
				member: "Mitglied",
				note: "Hinweis",
				result: "Ergebnis",
				states: {
					linked: "Verknüpft",
					link: "Verknüpfen",
					create: "Konto anlegen",
					adopt: "Konto übernehmen",
					blocked: "Blockiert",
				},
				matched_by_email: "Mitglied mit gleicher E-Mail-Adresse",
				matched_by_name: "Mitglied mit gleichem Namen",
				chosen_by_hand: "Mitglied von Hand gewählt",
				new_account: "Noch kein Konto – wird angelegt, Zugangsdaten per Mail",
				existing_account: "Konto ohne Organisation vorhanden – wird übernommen, keine Mail",
				link_member: "Mit Mitglied verknüpfen…",
				link_member_title: "{name} mit einem Mitglied verknüpfen",
				create_account_instead: "Stattdessen Konto anlegen",
				reset_suggestion: "Zurück zum Vorschlag",
				outcomes: {
					linked: "Verknüpft",
					created: "Konto angelegt",
					adopted: "Konto übernommen",
					failed: "Fehlgeschlagen",
				},
				email_not_sent:
					"Die Willkommensmail konnte nicht versendet werden. Die Person kann auf der Anmeldeseite „Passwort vergessen“ nutzen.",
				adopted_hint:
					"Die Person behält ihr bisheriges Passwort. „Passwort vergessen“ auf der Anmeldeseite vergibt ein neues.",
				summary_title: "Abgleich abgeschlossen",
				summary:
					"{created} angelegt, {adopted} übernommen, {linked} verknüpft, {failed} fehlgeschlagen",
				teams_not_synced_title: "Teams nicht aktualisiert",
				teams_not_synced:
					"Die Teams konnten nicht aus Personio aktualisiert werden. Starten Sie den Team-Abgleich in den Team-Einstellungen.",
				no_sync_role_title: "Keine Rolle für abgeglichene Personen",
				no_sync_role_description:
					"Legen Sie in den Einstellungen der Personio-Integration die Rolle für abgeglichene Personen fest, bevor Konten angelegt werden. Bestehende Mitglieder lassen sich auch ohne sie verknüpfen.",
				not_permitted_title: "Nur Inhaber und Admins legen Konten an",
				not_permitted_description:
					"Ein neues Konto vergibt eine Rolle. Personio-Personen mit bestehenden Mitgliedern verknüpfen können Sie trotzdem.",
				already_running:
					"Für diese Organisation läuft bereits ein Personio-Abgleich. Warten Sie, bis er abgeschlossen ist.",
				issues: {
					missing_email: "In Personio ist keine E-Mail-Adresse hinterlegt",
					email_in_use: "Die E-Mail-Adresse gehört bereits zu einem anderen Konto",
					ambiguous_match: "Mehrere Mitglieder passen zum Namen – bitte von Hand wählen",
					no_sync_role: "Keine Rolle für abgeglichene Personen festgelegt",
					not_permitted: "Nur Inhaber und Admins können Konten anlegen",
					not_in_personio: "Nicht unter den aktiven Personen in Personio",
					not_a_member: "Das gewählte Mitglied gehört nicht zur Organisation",
					member_linked_elsewhere:
						"Das Mitglied ist bereits mit einer anderen Personio-Person verknüpft",
					person_linked_elsewhere: "Die Person ist bereits mit einem anderen Mitglied verknüpft",
					duplicate_selection: "In diesem Abgleich doppelt gewählt",
					unexpected: "Unerwarteter Fehler",
				},
			},
			integration_not_found: "Diese Integration ist nicht mehr eingerichtet.",
			identifier_already_linked:
				"Die externe ID {identifier} ist bereits mit einem anderen Datensatz verknüpft. Jede externe ID kann nur einmal verknüpft werden.",
			personio_credentials_invalid:
				"Personio hat die Client-ID oder das Secret nicht akzeptiert. Prüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.",
			personio_credentials_rejected:
				"Personio akzeptiert die Zugangsdaten der Organisation nicht mehr. Richten Sie die Personio-Integration erneut ein.",
			personio_unavailable:
				"Personio hat nicht auf alle Anfragen geantwortet. Es wurde nichts geändert – versuchen Sie es in einer Minute erneut.",
		},
		organization: {
			business_hours: "Geschäftszeiten",
			business_hours_hint:
				"Eine Eingangsrechnung gilt mit der nächsten Öffnung als empfangen: Eine E-Mail, die außerhalb dieser Zeiten, an einem geschlossenen Tag oder an einem Feiertag eingeht, wird zur nächsten Öffnung empfangen.",
			business_hours_organization_hint:
				"Jeder Workspace ohne eigene Geschäftszeiten übernimmt diese.",
			business_hours_inherited_hint:
				"Dieser Workspace übernimmt die Geschäftszeiten der Organisation. Schalten Sie eigene Geschäftszeiten ein, um abweichende festzulegen.",
			own_business_hours: "Eigene Geschäftszeiten",
			business_hours_closed: "Geschlossen",
			reset_business_hours: "Auf Standard zurücksetzen",
			federal_state: "Bundesland",
			federal_state_hint:
				"Neben den bundesweiten Feiertagen werden die Feiertage dieses Bundeslands übersprungen.",
			bank_account: "Bankverbindung",
			bank_account_hint:
				"Von diesem Konto werden die Lieferanten der Rechnungen an diesen Workspace bezahlt.",
			bank_account_holder: "Kontoinhaber",
			iban: "IBAN",
			bic: "BIC",
			worksites: "Arbeitsstätten",
			automatic_break_buffer: "Puffer für automatische Pausen (Minuten)",
			automatic_break_buffer_description:
				"Ein Tag bis zu so vielen Minuten über 6 bzw. 9 Stunden Arbeit wird auf die Schwelle gekürzt, statt die volle gesetzliche Pause abzuziehen.",
			worksite_required_acknowledgements: "Erforderliche Bestätigungen",
			worksite_acknowledgement_definitions: {
				add: "Bestätigung hinzufügen",
				edit: "Bestätigung bearbeiten",
				delete_confirmation_message:
					"Möchten Sie diese Bestätigung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			},
			join_organization: "Organisation beitreten",
			join_organization_with_qr: "Mit QR-Code beitreten",
			join_organization_with_code: "Mit Code beitreten",
			invitation_code_should_look_like:
				"Der Einladungscode sollte wie folgt aussehen: ABCD-1A2B3C4D",
			connecting_organization_failed: "Verbindung zur Organisation fehlgeschlagen",
			cannot_partner_with_itself:
				"Eine Organisation kann keine Partnerschaft mit sich selbst eingehen.",
			connect_confirmation_title: "Als Nachunternehmer verbinden",
			connect_confirmation_message: "{name} kann dann Ihre Kolonnen buchen.",
			already_connected_with: "Sie sind bereits mit {name} verbunden.",
			open_partner: "Partner öffnen",
			copy_connect_link: "Link kopieren",
			show_qr_code: "QR-Code anzeigen",
			share_connect_link: "Link teilen",
			open_in_app: "In der App öffnen",
			connect_link_description:
				"Wer diesen Link öffnet, kann Ihr Nachunternehmer werden; die Partnerschaft bleibt ausstehend, bis Sie sie aktivieren.",
			connect_organization_description:
				"Geben Sie den Partnerschafts-Einladungscode ein, den Sie von der Partner-Organisation erhalten haben.",
			data: {
				unnamed_service: "Unbenannte Leistung",
				hierachy: "Hierarchie",
				data: "Daten",
				service: "Leistung",
				services: "Leistungen",
				add_service: "Leistung hinzufügen",
				add_custom_service: "Individuelle Leistung hinzufügen",
				select_service: "Leistung auswählen",
				edit_service: "Leistung bearbeiten",
				service_number: "Leistungsnummer",
				short_text: "Kurztext",
				long_text: "Langtext",
				fulfillment_type: "Erfüllungsart",
				fulfillment_partners: "Erfüllungspartner",
				add_fulfillment_partner: "Erfüllungspartner hinzufügen",
				remove_fulfillment_partner: "Erfüllungspartner entfernen",
				internal_service: "Interne Leistung",
				external_service: "Externe Leistung",
				parent_service: "Übergeordnete Leistung",
				atomic_number: "Atomare Nummer",
				delete_service_confirm:
					"Möchten Sie diese Leistung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
				unit_price: "Einzelpreis",
				min_unit_price: "Min. Einzelpreis",
				max_unit_price: "Max. Einzelpreis",
				service_not_found: "Diese Leistung existiert nicht mehr.",
			},
			add_workspace: "Workspace hinzufügen",
			company: "Unternehmen",
			create_organization: "Organisation erstellen",
			edit_workspace: "Workspace bearbeiten",
			logo: "Logo",
			members: "Mitglieder",
			organization: "Organisation",
			organization_color: "Organisationsfarbe",
			organization_size: "Organisationsgröße",
			organizations: "Organisationen",
			settings: "Organisationseinstellungen",
			teams: "Teams",
			team: "Team",
			team_leaders: "Teamleiter",
			team_leader: "Teamleiter",
			without_team: "Kein Team",
			sync_teams_with_personio: "Teams mit Personio synchronisieren",
			team_has_no_members: "Keine Mitglieder",
			team_capabilities: "Fähigkeiten",
			add_team: "Team hinzufügen",
			edit_team: "Team bearbeiten",
			delete_team: "Team löschen",
			delete_team_confirmation:
				"Möchten Sie dieses Team wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			delete_personio_team_confirmation:
				"Möchten Sie dieses Team wirklich löschen? Die Synchronisierung mit Personio legt es nicht wieder an. Diese Aktion kann nicht rückgängig gemacht werden.",
			invitation_codes: "Einladungscodes",
			partnership_invitation_code: "Partnerschafts-Einladungscode",
			partnership_invitation_code_description:
				"Teilen Sie diesen Code mit dem Administrator der Organisation, mit der Sie sich verbinden möchten.",
			workspace: "Workspace",
			workspace_not_found: "Workspace nicht gefunden",
			workspaces: "Workspaces",
			workspace_logo: "Logo",
			workspace_letterpaper: "Briefpapier",
			connect_organization: "Organisation verbinden",
			connected_organization: "Verbundene Organisation",
			connected_organization_successfully: "Organisation erfolgreich verbunden",
			invite_organization: "Organisation einladen",
			capabilities: {
				receive_substitution_list_copy: "Soll die Vertretungsliste erhalten",
				crew_scheduling: "Kann einer Kolonne zugewiesen werden",
				vehicle_scheduling: "Kann einem Fahrzeug zugewiesen werden",
				manage_project: "Kann ein Projekt verwalten oder vertreten",
				invoice_approval: "Kann Eingangsrechnungen prüfen",
			},
			activate_partnership: "Partnerschaft aktivieren",
			deactivate_partnership: "Partnerschaft deaktivieren",
			not_found: "Diese Organisation existiert nicht mehr.",
			invalid_invitation_code:
				"Dieser Einladungscode ist ungültig. Bitte prüfen Sie ihn und versuchen Sie es erneut.",
			team_not_found: "Dieses Team existiert nicht mehr.",
			alert_not_found: "Dieser Alarm existiert nicht mehr.",
			personio_not_connected: "Ihre Organisation ist nicht mit Personio verbunden.",
			personio_no_active_people:
				"Personio führt keine aktiven Personen, daher wurden die Teams nicht verändert.",
		},
		partners: {
			notification_requested_title: "Neue Partnerschaftsanfrage",
			notification_requested_message:
				"{name} hat Ihren Partnerschaftscode eingelöst. Aktivieren Sie die Partnerschaft, um ihre Kolonnen einzuplanen.",
			notification_activated_title: "Partnerschaft aktiviert",
			notification_activated_message:
				"{name} hat die Partnerschaft aktiviert und kann Ihre Kolonnen ab jetzt einplanen.",
			notification_deactivated_title: "Partnerschaft deaktiviert",
			notification_deactivated_message:
				"{name} hat die Partnerschaft deaktiviert. Bis zur erneuten Aktivierung sind keine Buchungen mehr möglich.",
			role: "Rolle",
			role_subcontractor: "Nachunternehmer",
			role_client: "Auftraggeber",
			direction_we_book: "Wir buchen {name}",
			direction_they_book: "{name} bucht uns",
			partner_reports_email: "E-Mail für Partnerberichte",
			add_agreement_as_follow_up_agreement: "Vereinbarung als Folgevereinbarung hinzufügen",
			add_booking: "Buchung hinzufügen",
			add_bookings: "Buchungen hinzufügen",
			review_bookings: "Buchungen prüfen",
			submit_bookings: "Buchungen einreichen",
			submit_bookings_short: "Einreichen",
			review_bookings_short: "Prüfen",
			all_bookings: "Alle Buchungen",
			nothing_open_this_week: "In dieser Woche ist nichts offen",
			nothing_this_week: "In dieser Woche gibt es keine Buchungen",
			filter_bookings: "Buchungen filtern",
			only_open_bookings: "Nur offene",
			n_open_booking_reviews: "{count} offene Buchungsprüfungen",
			n_required_bookings: "{count} erforderliche Buchungen",
			agreement_date_taken: "Vereinbarungsdatum bereits vergeben",
			agreement_date_taken_description:
				"Das ausgewählte Datum ist bereits durch eine andere Vereinbarung desselben Typs belegt. Bitte wählen Sie ein anderes Datum oder klicken Sie hier, um bestehende Vereinbarungen zu bearbeiten.",
			agreement_missing: "Vereinbarung fehlt",
			agreements: "Vereinbarungen",
			bookings: "Buchungen",
			start: "Start",
			end: "Ende",
			control_bookings: "Buchungen kontrollieren",
			controlled_hours: "Kontrollierte Stunden",
			early_payment_discount: "Skonto",
			early_payment_discount_payment_target: "Skonto - Zahlungsziel",
			hourly: "Stündlich",
			hourly_rate: "Stundensatz",
			hourly_total: "Stunden gesamt",
			my_partners: "Meine Partner",
			partner: "Partner",
			partners: "Partner",
			pause: "Pause",
			payment_target: "Zahlungsziel",
			service: "Leistung",
			total: "Gesamt",
			service_total: "Leistung gesamt",
			settlement_sum: "Abrechnungssumme",
			submitted_sum: "Eingereichte Summe",
			approve_booking: "Genehmigen",
			accept_booking: "Akzeptieren",
			accepted_booking: "Akzeptiert",
			approved_reference_hint:
				"Diese Buchung wurde genehmigt und kann nicht mehr bearbeitet werden.",
			reject_booking: "Ablehnen",
			rejected_booking: "Abgelehnt",
			adjusted_booking: "Angepasst",
			submitted_hours: "Eingereichte Stunden",
			valid_from: "Gültig ab",
			valid_until: "Gültig bis",
			host: "Gastgeber",
			send_report: "Bericht senden",
			sending_report: "Bericht wird gesendet",
			report_sent: "Bericht gesendet",
			report_failed: "Bericht fehlgeschlagen",
			send_copy_to_myself: "Kopie an mich selbst senden",
			uncaluclated: "Nicht berechnet",
			uncalculated_references_warning:
				"Diese Woche enthält nicht berechnete Referenzen. Möchten Sie den Bericht trotzdem senden?",
			reports: {
				report: "Bericht",
				reports: "Berichte",
				report_number: "Berichtsnummer",
				invoice_tracking: "Rechnungsverfolgung",
				last_sent: "Zuletzt gesendet",
				last_sent_by: "Zuletzt gesendet von",
				last_sent_at: "Zuletzt gesendet am",
			},
			booking_state: {
				open: "Offen",
				submitted: "Eingereicht",
				reviewed: "Geprüft",
				approved: "Genehmigt",
			},
			partnership_not_found: "Diese Partnerschaft existiert nicht mehr.",
			not_a_member: "Ihre Organisation ist nicht Teil dieser Partnerschaft.",
			agreement_not_found: "Diese Vereinbarung existiert nicht mehr.",
			reference_not_found: "Diese Buchung existiert nicht mehr.",
			report_reference_not_found: "Dieser Bericht existiert nicht mehr.",
			only_host_can_approve_bookings: "Nur die Gastgeber-Organisation kann Buchungen genehmigen.",
			only_host_can_change_calculation_type:
				"Nur die Gastgeber-Organisation kann die Abrechnungsart einer Buchung ändern.",
			nothing_to_update: "Es gibt keine Änderungen zum Speichern.",
			no_person_named: "Keine Person angegeben",
			remove_booking: "Buchung entfernen",
			not_reviewed_yet: "Noch nicht geprüft",
			day_not_published:
				"Für diesen Tag wurde noch kein Plan veröffentlicht. Stunden können erst nach der Veröffentlichung gebucht werden.",
			reference_approved:
				"Diese Buchung ist bereits genehmigt und kann nicht mehr geändert werden. Nimm die Genehmigung zurück, um die Stunden zu ändern.",
			bookings_changed:
				"Diese Buchungen wurden in der Zwischenzeit von jemand anderem geändert. Lade sie neu, um den aktuellen Stand zu sehen.",
			bookings_changed_title: "Buchungen zwischenzeitlich geändert",
			bookings_changed_description:
				"Jemand anderes hat diese Buchungen geändert, während du sie geöffnet hattest. Neu laden zeigt den aktuellen Stand und verwirft deine ungespeicherten Änderungen hier.",
			reload_bookings: "Buchungen neu laden",
			withdraw_approval_title: "Freigabe zurücknehmen?",
			withdraw_approval_message:
				"Die Buchungen werden für beide Seiten wieder bearbeitbar, und der Eintrag muss vor der Abrechnung erneut freigegeben werden.",
			withdraw_approval: "Freigabe zurücknehmen",
		},
		personnel: {
			absence: "Abwesenheit",
			absences: "Abwesenheiten",
			absence_is_not_editable: "Abwesenheit ist nicht bearbeitbar",
			employees: {
				absences: "Abwesenheiten",
				employee: "Mitarbeiter",
				employees: "Mitarbeiter",
			},
			events: "Veranstaltungen",
			fields: {
				email: "E-Mail",
				phone: "Telefon",
				position: "Position",
				web: "Web",
			},
			personnel: "Personal",
			employment: {
				job_title: "Berufsbezeichnung",
				valid_from: "Gültig ab",
				valid_to: "Gültig bis",
				employment: "Beschäftigung",
				add_employment: "Beschäftigung hinzufügen",
				edit_employment: "Beschäftigung bearbeiten",
				no_employment_available: "Keine Beschäftigung verfügbar",
				hours_per_week: "Stunden pro Woche",
			},
		},
		placeholders: {
			estimated_days: "z. B. 3",
			add_note: "Nützliche Notiz hinzufügen...",
			select_member: "Mitglied auswählen...",
			city: "Berlin",
			company_name: "ACME Gerüstbau GmbH",
			email: "max@mustermann.de",
			first_name: "Max",
			house_number: "13a",
			invoice_number: "RE-0001",
			last_name: "Mustermann",
			organization: "ACME Corp.",
			phone: "+49 123 456789",
			// Plain Date on purpose: date/moment.ts imports the locales barrel, so importing the
			// wrapped moment here closes an ESM cycle that crashes whichever consumer happens
			// to evaluate the date module first.
			project_number: `${new Date().getFullYear().toString().slice(-2)}-0123`,
			search: "Suche...",
			search_n_results: "{count} Ergebnisse durchsuchen...",
			street: "Mozartstraße",
			ticket_name: "8000m² SL100",
			title: "Titel",
			description: "Beschreibung hinzufügen...",
			text: "Text eingeben...",
			type_to_add: "Zum Hinzufügen tippen...",
			zip_code: "13158",
			web: "https://www.acme.com",
			resource_link_name: "Trimble-Modell",
			username: "max.mustermann",
			short_text: "Gerüstplanung Fassadengerüst",
			long_text:
				"Gerüstplanung des Fassadengerüstes, einschl. erforderlicher Ausführungszeichnungen für Konstruktionen außerhalb der DIN- und Herstellervorschrift...",
			select_service: "Leistung auswählen...",
			calculation_name: "Angebot für ACME Corp.",
			team_name: "Buchhaltung",
			role_name: "Bauleitung",
			stock: {
				article_group_name: "Systemfrei",
				article_product_type_name: "Kupplung/Rohrverbinder",
				article_name: "Normalkupplung",
				order_template_name: "Beispiel-Bestellvorlage",
				tour_name: "Frühe Morgentour",
				vendor_article_number: "5FSNN60001",
				warehouse_zone_name: "Halle A",
			},
			employment: {
				job_title: "Techniker",
			},
		},
		planning: {
			number_of_weeks: "Anzahl Wochen",
			calendar_weeks_count: "{count} Wochen",
			change_not_allowed: "Diese Änderung war nicht erlaubt",
			rules_could_not_be_loaded: "Deine Berechtigungen konnten nicht geladen werden",
			mark_all_tickets_as_skipped: "Alle Tickets als übersprungen markieren",
			assign_user: "Benutzer zuweisen",
			show_vehicles: "Fahrzeuge anzeigen",
			active: "Aktiv",
			collapse_all_days: "Alle Tage einklappen",
			copy_day: "Tag kopieren",
			notify_about_changes: "Über Änderungen benachrichtigen",
			crews_on_partner_board: "Unsere Kolonnen auf einer Partnertafel",
			copying_day: "Tag wird kopiert",
			resources: "Ressourcen",
			daily_planning: "Tagesplanung",
			capacity_planning: "Kapazitätsplanung",
			capacity_view_manager: "Bauleitung",
			other_managers: "Weitere Bauleiter",
			capacity_view_planner: "Kapazitätsplaner",
			calendar_week_short: "KW {week}",
			empty_day_label: "Kolonne hinzufügen oder einen Tag kopieren, um zu beginnen",
			hide_tickets: "Tickets ausblenden",
			show_tickets: "Tickets anzeigen",
			plan_published: "Plan veröffentlicht",
			plan_updated: "Plan aktualisiert",
			name_has_updated_the_plan_for: "{name} hat den Plan für {company} am {date} aktualisiert",
			name_has_published_the_plan_for: "{name} hat den Plan für {company} am {date} veröffentlicht",
			publish_plan: "Plan veröffentlichen",
			unpublish_plan: "Veröffentlichung aufheben",
			no_history_yet: "Noch kein Verlauf",
			crews: {
				tickets_count: "{count} Tickets",
				estimated_days_count: "{count} Tage",
				no_work_in_window: "Nichts in diesen Wochen geplant",
				edit_manager_slot: "Bauleiter-Zeitfenster bearbeiten",
				no_manager_slots: "Keine Bauleiter-Zeitfenster auf dieser Kolonne",
				my_manager_slots: "Meine Bauleiter-Zeitfenster",
				no_manager_slots_in_window: "Du hast in diesen Wochen keine Kolonnen",
				manager_slot_manager: "Bauleiter",
				schedule_crew: "Kolonne einplanen",
				outside_manager_slot: "Du hast diese Kolonne an diesen Tagen nicht",
				crew_not_active_yet: "Diese Kolonne existiert an diesen Tagen noch nicht",
				crew_already_ended: "Diese Kolonne ist vor diesen Tagen beendet",
				crew_does_not_work_those_days: "Diese Kolonne arbeitet nicht an jedem Tag dieses Zeitraums",
				work_does_not_fit_window: "{{count}} Tag(e) mehr als das Zeitfenster hergibt",
				add_work_break: "Pause hinzufügen…",
				scheduled_crew: "Kolonne",
				scheduled_from: "Vor Ort ab",
				scheduled_until: "Vor Ort bis",
				no_crew_scheduled: "Keine Kolonne eingeplant",
				manager_slot_start_date: "Zuständig ab",
				manager_slot_end_date: "Zuständig bis",
				add_manager_slot: "Bauleiter-Zeitfenster hinzufügen",
				crew_has_no_members: "Noch keine Mitglieder",
				crew_partner_helper_text:
					"Eine Partnerkolonne wird vom Partner besetzt, daher werden hier keine Mitarbeiter gewählt.",
				staffing_conflict_title: "Jemand ist bereits einer anderen Kolonne zugeteilt",
				staffing_conflict_line: "{user} ist vom {from} bis {to} bereits in {crew}",
				unnamed_crew: "Unbenannte Kolonne",
				add_crew_definition: "Kolonne hinzufügen",
				add_crew_member: "Mitglied hinzufügen",
				no_crews_in_window: "Keine Kolonnen in diesen Wochen aktiv",
				edit_crew_definition: "Kolonne bearbeiten",
				crew_name_placeholder: "z. B. Kolonne Nord",
				crew_start_date: "Aktiv ab",
				crew_end_date: "Aktiv bis",
				crew_members: "Kolonnenmitglieder",
				crew_lead: "Kolonnenführer",
				make_crew_lead: "Als Kolonnenführer festlegen",
				crew_member_count: "{count} Mitglieder",
				add_crew: "Kolonne hinzufügen",
				assign_crew: "Kolonne zuweisen",
				copy_crew: "Kolonne kopieren",
				crew: "Kolonne",
				crew_added: "Kolonne hinzugefügt",
				crews: "Kolonnen",
				crews_title: "Kolonnen",
				delete_crew: "Kolonne löschen",
				own_crew: "Eigene Kolonne",
				remove_from_crew: "Aus Kolonne entfernen",
			},
			editing: "In Bearbeitung",
			inactive: "Inaktiv",
			pending: "Ausstehend",
			published: "Veröffentlicht",
			unpublished: "Nicht veröffentlicht",
			drag_ticket_here: "Ticket hierher ziehen",
			drag_user_here: "Benutzer hierher ziehen",
			drag_vehicle_here: "Fahrzeug hierher ziehen",
			day_not_published_yet: "Tag noch nicht veröffentlicht",
			add_to_crew: "Zu {crew} hinzufügen",
			add_item_one: "1 Element hinzufügen",
			add_items_count: "{count} Elemente hinzufügen",
			plan_not_found: "Dieser Plan existiert nicht mehr.",
			plan_not_editable:
				"Dieser Tag ist veröffentlicht und kann nicht mehr geändert werden. Heben Sie die Veröffentlichung zuerst auf.",
			day_to_copy_not_found: "Für den Tag, den Sie kopieren möchten, gibt es keinen Plan.",
			crew_not_found: "Diese Kolonne existiert nicht mehr.",
			crew_organisation_not_partner: "Diese Organisation ist keiner Ihrer Partner.",
			crew_staffed_by_owner_only:
				"Nur die Organisation, der diese Kolonne gehört, kann sie besetzen.",
			assignment_not_found: "Dieser Eintrag ist nicht mehr auf der Tafel.",
			crew_does_not_work_on: "Diese Kolonne arbeitet am {date} nicht.",
			schedule_outside_ticket_window:
				"Eine Kolonne kann nur innerhalb des Zeitraums des Tickets eingeplant werden.",
			manager_slot_not_found: "Dieses Bauleiter-Zeitfenster existiert nicht mehr.",
			manager_slot_before_crew: "Ein Bauleiter-Zeitfenster kann nicht vor seiner Kolonne beginnen.",
			manager_slot_after_crew_ended:
				"Ein Bauleiter-Zeitfenster kann nicht nach dem Ende seiner Kolonne beginnen.",
			manager_slot_outlasts_crew:
				"Ein Bauleiter-Zeitfenster kann nicht über das Ende seiner Kolonne hinausgehen.",
			partner_crew_has_no_employees:
				"Eine Partnerkolonne wird vom Partner besetzt und kann keine Ihrer Mitarbeiter enthalten.",
			partner_crew_has_no_vehicles:
				"Einer Partnerkolonne kann keines Ihrer Fahrzeuge zugewiesen werden.",
			member_cannot_be_scheduled:
				"Jemand in dieser Kolonne gehört keinem Team an, das Kolonnen zugewiesen werden kann.",
		},
		profile: {
			avatar: "Avatar",
			first_name: "Vorname",
			invalid_push_token: "Der Push-Token ist kein gültiger Expo-Token.",
			full_name: "Vollständiger Name",
			last_name: "Nachname",
			initials: "Initialen",
			mr: "Herr",
			mrs: "Frau",
			profile: "Profil",
			profile_settings: "Profileinstellungen",
			change_profile_picture: "Profilbild ändern",
			choose_from_library: "Aus Mediathek wählen",
			take_photo: "Foto aufnehmen",
			title: "Titel",
			email_verified: "E-Mail verifiziert",
		},
		roles: {
			roles: "Rollen",
			role: "Rolle",
			member_count: "Personen",
			no_members: "Niemand",
			protected_hint: "Fest vorgegeben, nicht änderbar.",
			create_role: "Rolle anlegen",
			rename_role: "Rolle umbenennen",
			duplicate_role: "Rolle duplizieren",
			delete_role: "Rolle löschen",
			delete_confirmation_message:
				"Diese Rolle wird gelöscht. {count} Personen verlieren die Berechtigungen daraus — sofort und ersatzlos.",
			name_taken: "Eine Rolle mit diesem Namen existiert bereits.",
			not_found: "Diese Rolle existiert nicht mehr.",
			copy_suffix: "{name} (Kopie)",
			member_added: "Zur Rolle hinzugefügt.",
			member_removed: "Aus der Rolle entfernt.",
			add_member: "Mitglied hinzufügen",
			no_members_left: "Alle Mitarbeiter tragen diese Rolle bereits.",
			scope_none: "Kein Zugriff",
			scope_organization: "Alle",
			scope_own: "Nur eigene",
			scope_own_projects: "Nur eigene Projekte",
			scope_custom: "Individuell",
			scope_combined: "Aus Rollen kombiniert",
			scope_explanation_none: "Diese Aktion ist nicht erlaubt.",
			scope_explanation_organization: "Alle Einträge der Organisation.",
			scope_explanation_own_records: "Nur Einträge, die die Person selbst betreffen.",
			scope_explanation_own_created: "Nur Einträge, die die Person selbst erstellt hat.",
			scope_explanation_own_projects:
				"Nur in Projekten, bei denen die Person als Bauleiter oder Stellvertreter eingetragen ist oder gerade eine aktive Vertretung übernimmt.",
			scope_explanation_custom: "Individuell hinterlegte Bedingungen — hier nicht änderbar.",
			scope_explanation_combined: "Zusammengefasst aus den Reichweiten mehrerer Rollen.",
			admin_not_editable:
				"Die Admin-Rolle hält immer alle Berechtigungen und lässt sich nicht ändern.",
			members_locked:
				"Jeder in der Organisation ist Mitglied. Aus dieser Rolle kann niemand entfernt werden.",
			added_at: "Hinzugefügt am",
			added_by: "Hinzugefügt von",
			remove_member: "Aus der Rolle entfernen",
			remove_member_confirmation:
				"{name} verliert die Berechtigungen aus dieser Rolle — sofort und ersatzlos.",
			activate: "Aktivieren",
			deactivate: "Deaktivieren",
			deactivate_confirmation:
				"Die Rolle {role} wird für diesen Nutzer deaktiviert — ihre Berechtigungen entfallen sofort.",
			member_always_active: "Jeder ist Mitglied — diese Rolle lässt sich nicht deaktivieren.",
			owner_not_assignable:
				"Der Eigentümer hat bereits vollen Zugriff. Ihm können keine Rollen zugewiesen werden.",
		},
		projects: {
			manager_assigned_title: "Als Bauleiter eingetragen",
			manager_assigned_message: "{name} hat Sie als Bauleiter für {number} {project} eingetragen.",
			number_changed_title: "Projektnummer geändert",
			number_changed_message: "{name} hat die Nummer von {project} auf {number} geändert.",
			estimated_days: "Geschätzte Tage",
			estimated_days_exceeds_span: "In diesem Zeitfenster liegen nur {count} Arbeitstage",
			estimated_days_helper_text: "Wie viele Arbeitstage das Ticket im Zeitfenster oben benötigt.",
			no_project: "Kein Projekt",
			active_projects_one: "1 aktives Projekt",
			active_projects_count: "{count} aktive Projekte",
			select_project: "Projekt auswählen",
			change_project: "Projekt wechseln",
			project_search: "Projektsuche...",
			nearby_search: "Umgebungssuche",
			project_information: "Projektinformationen",
			ticket_information: "Ticketinformationen",
			open_project: "Projekt öffnen",
			project_settings: "Projekteinstellungen",
			invoicing_period: "Abrechnungszeitraum",
			invoicing_period_description: "Der Zeitraum, für den Abschlagsrechnungen erforderlich sind",
			last_invoice: "Letzte Rechnung",
			next_possible_invoice: "Nächstmögliche Rechnung",
			has_final_invoice: "Hat Schlussrechnung",
			has_progress_invoice: "Hat Abschlagsrechnung",
			has_single_invoice: "Hat Einzelrechnung",
			no_invoices_yet: "Noch keine Rechnungen",
			no_invoice_yet: "Noch keine Rechnung",
			_created_this_project: "hat dieses Projekt erstellt",
			_system_created_this_project: "Projekt wurde erstellt",
			_system_updated_this_project: "System hat dieses Projekt aktualisiert",
			_updated_this_project: "hat dieses Projekt aktualisiert",
			_updated_this_project_without_changes: "hat dieses Projekt ohne Änderungen aktualisiert",
			_merged_project_into_this_project: "hat {projectName} mit diesem Projekt zusammengeführt",
			activate_ticket: "Ticket aktivieren",
			add_project: "Projekt hinzufügen",
			add_ticket: "Ticket hinzufügen",
			new_tickets: "Neue Tickets",
			all_projects: "Alle Projekte",
			preferred_projects: "Bevorzugte Projekte",
			archive_ticket: "Ticket archivieren",
			assign_ticket: "Ticket zuweisen",
			copy_ticket: "Ticket kopieren",
			current_projects: "Aktuelle Projekte",
			deactivate_project: "Projekt deaktivieren",
			deactivate_ticket: "Ticket deaktivieren",
			edit_project: "Projekt bearbeiten",
			edit_ticket: "Ticket bearbeiten",
			delete_project: "Projekt löschen",
			delete_project_description:
				"Projekt und alle zugehörigen Daten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden. Alternativ können Sie dieses Projekt auf inaktiv setzen, um die Daten zu behalten und es aus der Projektliste auszublenden.",
			merge_project: "Projekt zusammenführen",
			merge_project_description:
				"Führen Sie dieses Projekt mit einem anderen Projekt zusammen. Dabei werden alle Daten dieses Projekts in das ausgewählte Projekt verschoben. Diese Aktion kann nicht rückgängig gemacht werden.",
			merge_project_select: "Projekt zum Zusammenführen auswählen",
			merge_project_direction: "Zusammenführungsrichtung",
			merge_project_direction_source_to_target: "Quelle zu Ziel",
			merge_project_direction_source_to_target_description:
				"Alle Daten dieses Projekts werden in das ausgewählte Projekt verschoben. Das ausgewählte Projekt wird zum Zielprojekt.",
			merge_project_direction_target_to_source: "Ziel zu Quelle",
			merge_project_direction_target_to_source_description:
				"Alle Daten des ausgewählten Projekts werden in dieses Projekt verschoben. Dieses Projekt wird zum Zielprojekt.",
			merge_project_target_cannot_be_same_as_source:
				"Das Zielprojekt darf nicht mit dem Quellprojekt identisch sein. Bitte wählen Sie ein anderes Projekt.",
			merging_projects: "Projekte werden zusammengeführt...",
			delete_project_confirm_message:
				"Möchten Sie dieses Projekt wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Dies betrifft auch alle mit diesem Projekt verbundenen Daten.",
			fields: {
				client: "Auftraggeber",
				manager: "Bauleiter",
				deputy_managers: "Stellvertretende Bauleiter",
				project_name: "Projektname",
				project_number: "Projekt-Nr.",
				related_project: "Verknüpftes Projekt",
				number: "Nummer",
				select_member: "Mitglied auswählen",
			},
			entries: "Einträge",
			my_projects: "Meine Projekte",
			project: "Projekt",
			project_acitivity: "Projektaktivität",
			projects: "Projekte",
			state: {
				active: "Aktiv",
				archived: "Archiviert",
				inactive: "Inaktiv",
			},
			ticket_date: "Ticket-Datum",
			ticket_type: "Ticket-Typ",
			ticket_types: "Ticket-Typen",
			ticket_type_not_found: "Ticket-Typ nicht gefunden",
			ticket_not_found: "Dieses Ticket existiert nicht mehr.",
			ticket_reference_not_found: "Dieses Ticket verweist auf etwas, das es nicht mehr gibt.",
			ticket: "Ticket",
			tickets: "Tickets",
			create_diary: "Bautagebuch erstellen",
			include_in_diary: "Im Bautagebuch einschließen",
			include_note_in_diary: "Notiz im Bautagebuch einschließen",
			include_notes_in_diary: "Notizen im Bautagebuch einschließen",
			include_media_in_diary: "Medien im Bautagebuch einschließen",
			include_unpublished_assignments_in_diary:
				"Unveröffentlichte Zuweisungen im Bautagebuch einschließen",
			note_is_included_in_diary: "Notiz ist im Bautagebuch enthalten",
			create_diary_asc: "Ältester Tag zuerst",
			create_diary_desc: "Neuester Tag zuerst",
			generate_project_summary: "Projektzusammenfassung erstellen",
			click_here_to_generate_project_summary:
				"Klicken Sie hier, um eine Projektzusammenfassung zu erstellen. Dies dauert einige Sekunden.",
			regenerate_project_summary: "Projektzusammenfassung neu erstellen",
			project_summary: "Projektzusammenfassung",
			remove_contact_from_project: "Kontakt aus Projekt entfernen",
			remove_contact_from_project_confirm_message:
				"Möchten Sie diesen Kontakt wirklich aus dem Projekt entfernen? Diese Aktion kann nicht rückgängig gemacht werden.",
			remove_member_from_project: "Mitglied aus Projekt entfernen",
			remove_member_from_project_confirm_message:
				"Möchten Sie dieses Mitglied wirklich aus dem Projekt entfernen? Diese Aktion kann nicht rückgängig gemacht werden.",
			edit_contact_project_override: "Kontakt für Projekt bearbeiten",
			reset_contact_project_override: "Kontakt auf Original zurücksetzen",
			reset_contact_project_override_confirmation:
				"Möchten Sie diesen Kontakt wirklich auf das Original zurücksetzen? Dadurch werden alle projektspezifischen Überschreibungen entfernt.",
			edit_member_project_override: "Mitglied für Projekt bearbeiten",
			reset_member_project_override: "Mitglied auf Original zurücksetzen",
			reset_member_project_override_confirmation:
				"Möchten Sie dieses Mitglied wirklich auf das Original zurücksetzen? Dadurch werden alle projektspezifischen Überschreibungen entfernt.",
			not_found: "Dieses Projekt existiert nicht mehr.",
			name_workspace_address_required:
				"Ein Projekt benötigt einen Namen, einen Workspace und eine Adresse.",
			related_project_not_found: "Das verknüpfte Projekt existiert nicht mehr.",
			invoice_project_mismatch: "Diese Rechnung gehört zu einem anderen Projekt.",
			staff_not_a_member:
				"Eine der ausgewählten Personen ist nicht mehr Mitglied der Organisation.",
			staff_not_active:
				"Eine der ausgewählten Personen ist kein aktives Mitglied der Organisation mehr.",
			timeline_note_not_found: "Diese Notiz in der Timeline existiert nicht mehr.",
			contact_not_assigned: "Dieser Kontakt ist dem Projekt nicht mehr zugeordnet.",
			contact_member_not_assigned: "Dieser Ansprechpartner ist dem Projekt nicht mehr zugeordnet.",
			ticket_window_too_short_for_estimate:
				"Die geschätzten Arbeitstage des Tickets passen nicht mehr in seinen Zeitraum.",
		},
		vehicles: {
			ignition: "Zündung",
			ignition_on: "Zündung an",
			ignition_off: "Zündung aus",
			speed: "Geschwindigkeit",
			driver_name: "Fahrername",
			orders: "Aufträge",
			cranes: "Kräne",
			elevators: "Aufzüge",
			vehicles: "Fahrzeuge",
			vehicle: "Fahrzeug",
			start: "Start",
			destination: "Ziel",
			add_vehicle: "Fahrzeug hinzufügen",
			select_vehicle: "Fahrzeug auswählen",
			edit_vehicle: "Fahrzeug bearbeiten",
			delete_vehicle: "Fahrzeug löschen",
			width: "Breite",
			height: "Höhe",
			depth: "Tiefe",
			license_plate: "Kennzeichen",
			vin: "FIN",
			manufacturer: "Hersteller",
			hsn: "HSN",
			tsn: "TSN",
			fuel_type: "Kraftstoffart",
			first_registration: "Erstzulassung",
			flatbed: "Pritsche",
			dimensions: "Fahrzeugabmessungen",
			maximum_load: "Maximale Zuladung",
			maximum_load_kg: "Maximale Zuladung (kg)",
			maximum_load_volume_m3: "Maximales Ladevolumen (m³)",
			front_crane: "Frontkran",
			tail_crane: "Heckkran",
			angle: "Kranwinkel",
			adc_kg: "ADC kg",
			weight_kg: "kg",
			meter: "m",
			crane_load: "Kranlast",
			add_crane_load: "Lastzeile hinzufügen",
			unknown_driver: "Unbekannter Fahrer",
			arrival: "Ankunft",
			expected_arrival: "Voraussichtliche Ankunft",
			types: {
				car: "PKW",
				other: "Sonstiges",
				pickup: "Pickup",
				trailer: "Anhänger",
				truck: "LKW",
				van: "Transporter",
			},
			fuel_types: {
				diesel: "Diesel",
				petrol: "Benzin",
				electric: "Elektro",
				hybrid: "Hybrid",
				other: "Sonstiges",
			},
			delete_vehicle_confirm_message:
				"Möchten Sie dieses Fahrzeug wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			connect_vehicle_to_webfleet_object: "Fahrzeug mit Webfleet-Objekt verbinden",
			order_type: {
				delivery: "Lieferung",
				pickup: "Abholung",
				service: "Service",
				unknown: "Unbekannt",
			},
			not_found: "Dieses Fahrzeug existiert nicht mehr.",
		},
		settings: {
			settings: "Einstellungen",
		},
		spotlight: {
			action: "Aktion",
		},
		tables: {
			actions: "Aktionen",
			add_column: "Spalte hinzufügen",
			add_row: "Zeile hinzufügen",
			columns: "Spalten",
			filtered_items: "Gefilterte Elemente",
			visible_items: "Sichtbare Elemente",
			formatting_has_been_reset: "Formatierung wurde zurückgesetzt",
			hide_column: "Spalte ausblenden",
			insert_column_left: "Spalte links einfügen",
			insert_column_right: "Spalte rechts einfügen",
			insert_row: "Zeile einfügen",
			insert_row_above: "Zeile darüber einfügen",
			insert_row_below: "Zeile darunter einfügen",
			insert_table: "Tabelle einfügen",
			items_per_page: "Elemente pro Seite",
			merge_cells: "Zellen zusammenführen",
			no_data_available: "Keine Daten verfügbar",
			no_data_available_for_current_filter: "Keine Daten für den aktuellen Filter verfügbar",
			pin: "Anheften",
			pin_left: "Links anheften",
			pin_right: "Rechts anheften",
			remove_column: "Spalte entfernen",
			remove_row: "Zeile entfernen",
			reset_formatting: "Formatierung zurücksetzen",
			reset_sorting: "Sortierung zurücksetzen",
			show_column: "Spalte anzeigen",
			sort_ascending: "Aufsteigend sortieren",
			sort_descending: "Absteigend sortieren",
			sorted: "Sortiert",
			split_cells: "Zellen teilen",
			total_items: "Elemente gesamt",
			unpin: "Lösen",
			n_items_selected: "{count} Elemente ausgewählt",
			move_column_left: "Spalte nach links verschieben",
			move_column_right: "Spalte nach rechts verschieben",
			show_grouping_header: "Gruppierungskopf anzeigen",
			fold_all: "Alle einklappen",
		},
		substitutions: {
			summary: "Zusammenfassung",
			substitutions: "Vertretungen",
			substitution_plan: "Vertretungsplan",
			no_assignment_required: "Keine Vertretung erforderlich",
			assignment_not_required: "Vertretung nicht erforderlich",
			n_assigned: "{count} zugewiesen",
			assign_substitutes: "Vertretungen zuweisen",
			start_substitution_plan: "Vertretungsplan starten",
			plan_not_started_yet: "Dieser Vertretungsplan wurde noch nicht gestartet.",
			submit_substitution_plan: "Vertretungsplan einreichen",
			collision_warning: "Einige Vertretungen sind in diesem Zeitraum abwesend",
			is_expired: "Ist abgelaufen",
			notify_contacts: "Kontakte benachrichtigen",
			checking_for_collisions: "Kollisionen werden geprüft",
			this_hint_is_only_internally_visible: "Dieser Hinweis ist nur intern sichtbar",
			please_edit_all_projects: "Bitte bearbeiten Sie alle Projekte vor dem Absenden",
			please_edit_this_project: "Bitte bearbeiten Sie dieses Projekt",
			n_contacts_will_be_notified: "{count} Kontakte werden benachrichtigt",
			notify: "Benachrichtigen",
			dont_notify: "Nicht benachrichtigen",
			mute_all_contacts: "Alle Kontakte stummschalten",
			process_substitution_plan: "Vertretungsplan bearbeiten",
			show_unanswered_items_only: "Nur unbeantwortete Einträge anzeigen",
			edit_substitution_plan: "Vertretungsplan bearbeiten",
			send_notification_emails_on_a_later_date:
				"Benachrichtigungs-E-Mails zu einem späteren Zeitpunkt senden",
			finish_substitution_list: "Vertretungsliste abschließen",
			show_summary: "Zusammenfassung anzeigen",
			copy_previous_plan_message:
				"Möchten Sie die Notizen, Zuweisungen und Kontakte aus Ihrem vorherigen Vertretungsplan übernehmen?",
			copy_previous_plan_confirm: "Vorherigen Plan übernehmen",
			copy_previous_plan_reject: "Leer beginnen",
			not_found: "Dieser Vertretungsplan existiert nicht mehr.",
		},
		tasks: {
			assignee: "Zugewiesene Person",
			assignee_helper_text:
				"Wählen Sie einen Benutzer oder Partner aus, dem diese Aufgabe zugewiesen werden soll.",
			task: "Aufgabe",
			tasks: "Aufgaben",
			n_tasks: "{count} Aufgaben",
		},
		theme: {
			accent: "Akzent",
			amber: "Bernstein",
			azure: "Azurblau",
			blue: "Blau",
			color: "Farbe",
			cyan: "Cyan",
			dark: "Dunkel",
			"ember-blaze": "Glutrot",
			emerald: "Smaragd",
			fern: "Farn",
			gray: "Grau",
			green: "Grün",
			icon: "Icon",
			indigo: "Indigo",
			jade: "Jade",
			light: "Hell",
			lime: "Limette",
			orange: "Orange",
			primary: "Primär",
			purple: "Lila",
			red: "Rot",
			rose: "Rose",
			salmon: "Lachs",
			sky: "Himmel",
			slate: "Schiefer",
			stone: "Stein",
			teal: "Türkis",
			theme: "Erscheinungsbild",
			violet: "Violett",
			yellow: "Gelb",
			zinc: "Zink",
			system: "System",
			use_system_theme: "Systemdesign verwenden",
			using_system_theme: "Sie verwenden jetzt das Systemdesign.",
		},
		timeline: {
			timeline: "Timeline",
		},
		tiptap: {
			bold: "Fett",
			characters: "Zeichen",
			italic: "Kursiv",
			paragraph: "Absatz",
			strikethrough: "Durchgestrichen",
			underline: "Unterstrichen",
		},
		units: {
			select_unit: "Einheit auswählen",
			piece: "Stück",
			piece_week: "Stück / Woche",
			business_days: "Werktage",
			calendar_days: "Kalendertage",
			cubic_meters: "Kubikmeter",
			weeks: "Wochen",
			currency: "Währung",
			days: "Tage",
			meters: "Meter",
			meters_week: "Meter / Woche",
			number: "Anzahl",
			percent: "Prozent",
			square_meters: "Quadratmeter",
			square_meters_week: "m² / Woche",
			unit: "Einheit",
			work_days: "Arbeitstage",
			flat_rate: "Pauschale",
			centimeters: "Zentimeter",
			millimeters: "Millimeter",
			kilometers: "Kilometer",
			hours: "Stunden",
			gram: "Gramm",
			grams: "Gramm",
			kilogram: "Kilogramm",
			kilograms: "Kilogramm",
			ton: "Tonne",
			tons: "Tonnen",
		},
		users: {
			add_user: "Benutzer hinzufügen",
			user_added: "Benutzer hinzugefügt.",
			select_user: "Benutzer auswählen...",
			invite_users: "Benutzer einladen",
			my_profile: "Mein Profil",
			permission: "Berechtigung",
			permissions: "Berechtigungen",
			role: "Rolle",
			roles: "Rollen",
			user: "Benutzer",
			user_does_not_exist: "Benutzer existiert nicht mehr",
			users: "Benutzer",
			signed_up: "registriert",
			email_verified: "E-Mail verifiziert",
			resend_verification_email: "Bestätigungs-E-Mail erneut senden",
			verification_email_sent: "Bestätigungs-E-Mail gesendet",
			remove_user_from_organization: "Benutzer aus Organisation entfernen",
			remove_user_from_organization_description:
				"Entfernt den Benutzer aus der Organisation. Dadurch wird der Benutzer aus allen Projekten und Leistungen entfernt.",
			remove_user_from_organization_successfully:
				"Benutzer erfolgreich aus der Organisation entfernt",
			remove_user_from_organization_confirm_message:
				"Möchten Sie diesen Benutzer wirklich aus der Organisation entfernen? Sie können diesen Benutzer später wieder einladen.",
			set_active: "Aktiv setzen",
			set_active_description:
				"Setzt den Status des Benutzers auf aktiv, sodass er standardmäßig in der Benutzerliste erscheint und Kolonnen oder Projekten zugewiesen werden kann.",
			set_inactive: "Inaktiv setzen",
			set_inactive_description:
				"Setzt den Status des Benutzers auf inaktiv, sodass er standardmäßig nicht in der Benutzerliste erscheint und nicht mehr Kolonnen oder Projekten zugewiesen werden kann. Außerdem kann er nicht mehr auf die App in Ihrer Organisation zugreifen.",
			current_attendance: "Aktuelle Anwesenheit",
			attendances: "Anwesenheiten",
			attendance_approvals: "Anwesenheitsfreigaben",

			my_attendances: "Meine Anwesenheiten",
			not_started: "Nicht begonnen",
			attendance: "Anwesenheit",
			attendance_has_been_rejected: "{name} hat Ihre Anwesenheit abgelehnt",
			attendance_has_been_approved: "{name} hat Ihre Anwesenheit genehmigt",
			substitution_assigned_title: "Sie wurden als Vertretung eingeteilt",
			substitution_assigned_message:
				"{name} ist vom {from} bis {to} abwesend. Sie vertreten in dieser Zeit.",
			edit_attendance: "Anwesenheit bearbeiten",
			worksite: "Arbeitsort",
			current_worksite: "Aktueller Arbeitsort",
			new_worksite: "Neuer Arbeitsort",
			change_worksite: "Arbeitsort ändern",
			slide_to_start_attendance: "Zum Starten der Anwesenheit schieben",
			slide_to_end_attendance: "Zum Beenden der Anwesenheit schieben",
			last_14_days: "Letzte 14 Tage",
			last_30_days: "Letzte 30 Tage",
			attendance_duration: "Dauer",
			attendance_running: "Läuft",
			attendance_insights: "Auswertung",
			average_per_workday: "Ø pro Arbeitstag",
			days_worked: "Arbeitstage",
			total_work: "Gesamt",
			average_break: "Ø Pause",
			off_schedule_work: "Außerplanmäßig",
			attendance_balance: "Saldo",
			pending_entries: "Ausstehend",
			missing_check_out_title: "Abmeldung fehlt",
			missing_check_out_description_one:
				"An einem Tag der letzten 30 Tage wurde eine Anwesenheit nie beendet. Der Tag zählt als nicht gearbeitet.",
			missing_check_out_description_count:
				"An {count} Tagen der letzten 30 Tage wurde eine Anwesenheit nie beendet. Diese Tage zählen als nicht gearbeitet.",
			rejected_attendances_title: "Abgelehnte Einträge",
			rejected_attendances_description_one:
				"Eine Ihrer Anwesenheiten wurde abgelehnt. Bitte korrigieren, damit die Stunden zählen.",
			rejected_attendances_description_count:
				"{count} Ihrer Anwesenheiten wurden abgelehnt. Bitte korrigieren, damit die Stunden zählen.",
			attendance_state: {
				pending: "Ausstehend",
				approved: "Genehmigt",
				rejected: "Abgelehnt",
			},
			attendance_type: {
				work: "Arbeit",
				break: "Pause",
				automatic_break: "Automatische Pause",
			},
			add_attendance: "Anwesenheit nachtragen",
			attendance_end_before_start: "Das Ende muss nach dem Beginn liegen",
			attendance_in_the_future: "Eine Anwesenheit kann nicht in der Zukunft liegen",
			attendance_overlaps_live: "Der Eintrag reicht in die laufende Anwesenheit hinein",
			source_type: {
				web: "Web",
				mobile: "App",
				terminal: "Terminal",
				system: "Automatisch",
			},
			worksite_type: {
				home_office: "Home-Office",
				office: "Büro",
				project_site: "Baustelle",
				warehouse: "Lager",
				commute: "Anfahrt",
			},
			reject_attendance_reason: "Grund",
			check_in: "Einchecken",
			check_out: "Auschecken",
			slide_to_check_in: "Zum Einchecken schieben",
			slide_to_check_out: "Zum Auschecken schieben",
			confirm_attendance: "Anwesenheit bestätigen",
			i_accept_the_risk_assessments: "Ich akzeptiere die Gefährdungsbeurteilungen",
			risk_assessment: "Gefährdungsbeurteilung",
			risk_assessments: "Gefährdungsbeurteilungen",
			required_acknowledgements: "Erforderliche Bestätigungen",
			acknowledgements_required: "Für das Einchecken fehlen erforderliche Bestätigungen.",
			acknowledged: "Bestätigt",
			not_acknowledged: "Nicht bestätigt",
			not_a_member: "Diese Person ist kein Mitglied Ihrer Organisation.",
			team_not_found:
				"Eines der ausgewählten Teams existiert nicht mehr. Laden Sie die Seite neu und wählen Sie erneut.",
			owner_not_removable: "Der Eigentümer kann nicht aus der Organisation entfernt werden.",
			attendance_worksite_required: "Wählen Sie einen Arbeitsort, um einzuchecken.",
			no_live_attendance:
				"Sie sind nicht eingecheckt. Checken Sie ein, bevor Sie den Arbeitsort wechseln.",
		},
		absences: {
			absence_approvals: "Abwesenheitsfreigaben",
			absence_calendar: "Abwesenheitskalender",
			past: "Vergangen",
			upcoming: "Bevorstehend",
			only_show_upcoming: "Nur bevorstehende anzeigen",
			current: "Aktuell",
			absences: "Abwesenheiten",
			absence: "Abwesenheit",
			my_absences: "Meine Abwesenheiten",
			absence_type: "Abwesenheitsart",
			add_absence: "Abwesenheit hinzufügen",
			edit_absence: "Abwesenheit bearbeiten",
			vacation_days: "Urlaubstage",
			default_vacation_days: "Standard-Urlaubstage",
			vacation_days_expire: "Urlaubstage verfallen",
			vacation_days_expire_at: "Urlaubstage verfallen am",
			requires_document: "Erfordert Dokument",
			requires_approval: "Erfordert Genehmigung",
			deducts_from_balance: "Wird vom Kontingent abgezogen",
			half_day: "Halber Tag",
			delete_absences_confirm_message: "Möchten Sie diese Abwesenheit wirklich löschen?",
			absences_categories: "Abwesenheitskategorien",
			default_half_days: "Standard-Halbtage",
			add_half_day: "Halben Tag hinzufügen",
			accrual_type: {
				accrual_type: "Anspruchsart",
				accrual_type_description:
					"Monatlich: Tage werden jeden Monat angesammelt. Im Voraus: Alle Tage werden zu Jahresbeginn gewährt.",
				monthly: "Monatlich",
				upfront: "Im Voraus",
			},
			category: {
				category: "Kategorie",
				categories: "Kategorien",
				vacation: "Urlaub",
				sick: "Krankheit",
				leave: "Freistellung",
				compensation: "Ausgleich",
			},
			state: {
				pending: "Ausstehend",
				approved: "Genehmigt",
				rejected: "Abgelehnt",
				cancelled: "Storniert",
			},
			not_own: "Sie können nur Ihre eigenen Abwesenheiten einsehen und ändern.",
			not_found: "Diese Abwesenheit existiert nicht mehr.",
			already_started:
				"Diese Abwesenheit hat bereits begonnen und kann nicht mehr geändert oder gelöscht werden. Bitte wenden Sie sich an Ihren Administrator.",
		},
		visiblity: {
			private: "Privat",
			public: "Öffentlich",
			restricted: "Eingeschränkt",
			visiblity: "Sichtbarkeit",
		},
		wiki: {
			add_page: "Seite hinzufügen",
			add_space: "Bereich hinzufügen",
			are_you_sure_you_want_to_delete_this_page:
				"Möchten Sie diese Seite wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			are_you_sure_you_want_to_delete_this_page_and_all_its_content:
				"Möchten Sie diese Seite und alle ihre Inhalte und Unterseiten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			are_you_sure_you_want_to_delete_this_space:
				"Möchten Sie diesen Bereich wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Dies betrifft auch alle Seiten in diesem Bereich.",
			attach_file: "Datei anhängen",
			copy_page: "Seite kopieren",
			created_on: "erstellt am {date}",
			created_on_by: "erstellt am {date} von {name}",
			delete_page: "Seite löschen",
			delete_space: "Bereich löschen",
			edit_page: "Seite bearbeiten",
			edit_space: "Bereich bearbeiten",
			files: "Dateien",
			last_edited: "zuletzt bearbeitet {time}",
			no_pages_yet: "Noch keine Seiten",
			no_spaces_available: "Keine Bereiche verfügbar",
			page: "Seite",
			page_content: "Inhalt",
			page_not_found: "Diese Seite existiert nicht mehr.",
			page_title: "Titel",
			page_title_placeholder: "Seitentitel eingeben...",
			pages: "Seiten",
			save_as_template: "Als Vorlage speichern",
			select_page: "Seite auswählen",
			select_space: "Bereich auswählen",
			space: "Bereich",
			space_description: "Beschreibung",
			space_name: "Name",
			spaces: "Bereiche",
			sub_pages: "Unterseiten",
			untitled: "Unbenannt",
			wiki: "Wiki",
			you_are_currently_editing_changing_the_page_will_lose_your_changes:
				"Sie bearbeiten gerade. Ein Seitenwechsel verwirft Ihre Änderungen. Möchten Sie wirklich fortfahren?",
			record_needs_saveable_page:
				"Fülle zuerst die Pflichtfelder der Seite aus — die Aufnahme wird in der gespeicherten Seite verankert.",
			save_before_recording_failed:
				"Die Seite konnte nicht gespeichert werden, deshalb wurde die Aufnahme abgebrochen.",
			stop_recording: "Aufnahme stoppen",
			recording_in_progress: "Aufnahme läuft...",
		},
		statistics: {
			statistics: "Statistiken",
		},
		protocols: {
			added_as_involved_title: "Zu einem Protokoll hinzugefügt",
			added_as_involved_message:
				"{name} hat Sie als Beteiligten zum Protokoll „{title}“ hinzugefügt.",
			protocol: "Protokoll",
			protocols: "Protokolle",
			title: "Titel",
			meeting: "Besprechungsprotokoll",
			negotiation: "Verhandlungsprotokoll",
			call_note: "Gesprächsnotiz",
			call_request: "Rückrufwunsch",
			general: "Allgemeines Protokoll",
			templates: "Vorlagen",
			type: "Typ",
			types: "Typen",
			recipients: "Empfänger",
			location: "Ort",
			attendees: "Teilnehmer",
			add_section: "Abschnitt hinzufügen",
			delete_section_confirm_message:
				"Möchten Sie diesen Abschnitt wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			section_title_placeholder: "Abschnittstitel (optional)",
			protocol_subject: "Protokollbetreff",
			select_subject: "Betreff auswählen",
			protocol_subject_project: "Projekt",
			protocol_subject_offer: "Angebot",
			protocol_subject_other: "Sonstiges",
			short_description: "Kurzbeschreibung",
			protocol_title: "Protokolltitel",
			create_protocol: "Protokoll erstellen",
			edit_protocol: "Protokoll bearbeiten",
			are_you_sure_you_want_to_dismiss_this_protocol:
				"Möchten Sie dieses Protokoll wirklich verwerfen? Diese Aktion kann nicht rückgängig gemacht werden.",
			context: "Kontext",
			content: "Inhalt",
			call_request_for_user: "Rückrufwunsch für Benutzer",
			caller: "Anrufer",
			no_recipients: "Keine Empfänger",
			callback_time: "Rückrufzeit",
			send_notification: "Benachrichtigung senden",
			add_users_or_contact_members: "Benutzer oder Kontaktmitglieder hinzufügen...",
			involvements: "Beteiligungen",
			count_involvements: "{count} Beteiligungen",
			untitled: "Unbenannt",
			related_protocols: "Zugehörige Protokolle",
			callback_log: "Rückrufprotokoll",
			callback_resolved: "Zurückgerufen",
			callback_open: "Rückruf offen",
			callback_attempt: "Fehlversuch",
			count_callback_attempts: "{count} Fehlversuche",
			mark_as_called_back: "Als zurückgerufen markieren",
			log_failed_attempt: "Fehlversuch erfassen",
			no_callback_events: "Noch kein Rückruf erfasst",
			callback_note: "Notiz",
			callback_note_placeholder: "Was ist beim Anruf passiert?",
			export_pdf: "Als PDF exportieren",
			pdf_created: "PDF erstellt und an das Protokoll angehängt",
			send_protocol: "Protokoll versenden",
			send_with_attachment: "Als PDF anhängen",
			send_copy_to_me: "Kopie an mich senden",
			no_email_address: "Keine E-Mail-Adresse",
			sent_emails: "Versendete E-Mails",
			no_sent_emails: "Noch nichts versendet",
			protocol_sent: "Protokoll an {count} Empfänger versendet",
			protocol_sent_partial: "Protokoll an {count} von {total} Empfängern versendet",
			protocol_sent_to_nobody: "Das Protokoll konnte an keinen Empfänger versendet werden",
			protocol_not_loaded: "Das Protokoll konnte nicht geladen werden",
			not_found: "Dieses Protokoll existiert nicht mehr.",
			project_not_found: "Dieses Projekt existiert nicht mehr.",
			colleague_not_found: "Eine der genannten Personen ist kein Mitglied dieser Organisation.",
			contact_member_not_found: "Einer der genannten Ansprechpartner existiert nicht mehr.",
			no_recipient_with_email: "Keiner der Beteiligten dieses Protokolls hat eine E-Mail-Adresse.",
		},
		priority: {
			priority: "Priorität",
			low: "Niedrig",
			medium: "Mittel",
			high: "Hoch",
			very_high: "Sehr hoch",
			custom: "Benutzerdefiniert",
		},
		filter: {
			match_any_or: "Beliebige Übereinstimmung (ODER)",
			match_all_and: "Alle Übereinstimmungen (UND)",
		},
		webfleet: {
			integration_not_available:
				"Webfleet-Integration ist nicht verfügbar. Bitte wenden Sie sich an Ihren Administrator.",
			destination: "Ziel",
			odometer: "Kilometerstand",
			ordertext: "Auftragstext",
			tripmode: {
				tripmode: "Fahrtmodus",
				private_trip: "Privatfahrt",
				business_trip: "Geschäftsfahrt",
				unknown_trip_type: "Unbekannter Fahrttyp",
				commute_trip: "Arbeitsweg",
				correction_trip: "Korrekturfahrt",
			},
			order_states: {
				order_state: "Auftragsstatus",
				not_yet_sent: "Noch nicht gesendet",
				sent: "Gesendet",
				received: "Empfangen",
				read: "Gelesen",
				accepted: "Akzeptiert",
				service_order_started: "Serviceauftrag gestartet",
				arrived_at_destination: "Am Ziel angekommen",
				work_started: "Arbeit begonnen",
				work_finished: "Arbeit beendet",
				departed_from_destination: "Vom Ziel abgefahren",
				proof_of_delivery: "Zustellnachweis",
				pickup_order_started: "Abholauftrag gestartet",
				arrived_at_pickup_location: "Am Abholort angekommen",
				pickup_started: "Abholung begonnen",
				pickup_finished: "Abholung beendet",
				departed_from_pickup_location: "Vom Abholort abgefahren",
				delivery_order_started: "Lieferauftrag gestartet",
				arrived_at_delivery_location: "Am Lieferort angekommen",
				delivery_started: "Lieferung begonnen",
				delivery_finished: "Lieferung beendet",
				departed_from_delivery_location: "Vom Lieferort abgefahren",
				resumed: "Fortgesetzt",
				suspended: "Ausgesetzt",
				cancelled: "Storniert",
				rejected: "Abgelehnt",
				finished: "Abgeschlossen",
			},
			vehicle_types: {
				ape: "Ape",
				barge: "Lastkahn",
				bike: "Fahrrad",
				boom_lift: "Hubarbeitsbühne",
				boom_lift_truck: "Hubarbeitsbühnen-LKW",
				bus: "Bus",
				caddy: "Kleintransporter",
				car: "PKW",
				car_station_wagon: "Kombi",
				concrete_lorry: "Betonmischer",
				containership: "Containerschiff",
				crane: "Kran",
				deposit_tipper: "Absetzkipper",
				dump_truck: "Kipper",
				dump_truck_open: "Offener Kipper",
				excavator: "Bagger",
				garbage_truck: "Müllwagen",
				heavy_truck: "Schwerlaster",
				heavytruck_us: "Schwerlaster (US)",
				heavyweight_truck: "Schwerlast-LKW",
				heavyweight_truck_trailer: "Schwerlast-LKW mit Anhänger",
				lighttruck: "Leichter LKW",
				light_truck_pallet: "Leichter LKW (Pritsche)",
				loader: "Radlader",
				medium_truck: "Mittlerer LKW",
				multicar: "Multicar",
				multivan: "Großraumtransporter",
				pallet_truck: "Gabelstapler",
				pickup: "Pickup",
				smart: "Smart",
				sprinter: "Sprinter",
				street_sweeper: "Kehrmaschine",
				suv: "SUV",
				tanker_truck: "Tankwagen",
				telescopic_handler: "Teleskoplader",
				tractor: "Traktor",
				trailer: "Anhänger",
				train: "Zug",
				truck_loader_arm: "LKW mit Ladekran",
				truck_trailer: "LKW-Anhänger",
				truck_with_trailer: "LKW mit Anhänger",
				truck_wrecker: "Abschleppwagen",
				van: "Transporter",
				vespa: "Vespa",
				wrecker: "Abschleppwagen",
				yacht: "Yacht",
				ambulance: "Krankenwagen",
				firetruck: "Feuerwehrauto",
				police: "Polizei",
				taxi: "Taxi",
				taxi_uk: "Taxi (UK)",
			},
		},
		insights: {
			ask_ai: "KI fragen",
			ask_a_question: "Stellen Sie eine Frage zu Ihren Daten",
			placeholder: "z. B. Wie hoch ist der Durchschnittspreis für ein Schutzgerüst?",
			searching: "Wird gesucht...",
			no_rows: "Es wurden keine passenden Datensätze gefunden.",
			cant_answer: "Diese Frage konnte anhand der verfügbaren Daten nicht beantwortet werden.",
			view_record: "Datensatz anzeigen",
			raw_data: "Rohdaten",
		},
		calculations: {
			expand_sidebar: "Seitenleiste ausklappen",
			collapse_sidebar: "Seitenleiste einklappen",
			convert_to_project: "In Projekt umwandeln",
			calculation_was_alreay_converted: "Kalkulation wurde bereits umgewandelt",
			remove_assignment_from_calculation: "Zuweisung aus Kalkulation entfernen",
			remove_from_parent: "Aus übergeordnetem Element entfernen",
			move_down: "Nach unten verschieben",
			move_up: "Nach oben verschieben",
			add_calculation: "Kalkulation hinzufügen",
			from_file: "Aus Datei",
			from_scratch: "Von Grund auf",
			offer_upload_hint:
				"Legen Sie eine .pdf, .x83/.d83 (LV) oder .x83/.d83 + .x84/.d84 zusammen ab",
			offer_building: "Ihre Kalkulation wird erstellt, einen Moment...",
			offer_missing_x83:
				"Bitte fügen Sie auch die passende .x83/.d83-Datei zu Ihrer .x84/.d84-Datei hinzu",
			importing_offer: "Angebot wird gelesen...",
			import_offer: "Kalkulation erstellen",
			offer_imported: "Die Kalkulation wurde erstellt.",
			offer_import_failed: "Aus dieser Datei konnte keine Kalkulation erstellt werden.",
			eventual_position: "Eventualposition (E.P.)",
			add_to_calculation: "Zur Kalkulation hinzufügen",
			create_calculation: "Kalkulation erstellen",
			delete_calculation: "Kalkulation löschen",
			delete_calculation_confirm_message:
				"Möchten Sie diese Kalkulation wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Alle zugehörigen Daten werden ebenfalls gelöscht. Dies betrifft auch alle Verweise auf diese Kalkulation in anderen Instanzen.",
			edit_calculation: "Kalkulation bearbeiten",
			calculation: "Kalkulation",
			calculations: "Kalkulationen",
			pending: "Ausstehend",
			locked: "Gesperrt",
			result: "Ergebnis",
			created_calculation: "Kalkulation erstellt",
			add_service_to_calculation: "Leistung zur Kalkulation hinzufügen",
			add_services_to_start_calculation:
				"Fügen Sie Leistungen hinzu, um die Kalkulation zu starten",
			find_a_name_to_identify_your_calculation_later:
				"Finden Sie einen Namen, um Ihre Kalkulation später wiederzuerkennen",
			quantity: "Menge",
			length: "Länge",
			width: "Breite",
			width_short: "B",
			height: "Höhe",
			height_short: "H",
			depth: "Tiefe",
			depth_short: "T",
			meters: "Meter",
			weight: "Gewicht",
			adjusted_unit_price_to_min: "Einzelpreis auf Minimum angepasst ({minPrice})",
			adjusted_unit_price_to_max: "Einzelpreis auf Maximum angepasst ({maxPrice})",
			preparing_calculation: "Kalkulation wird vorbereitet...",
			calculation_not_loadable: "Diese Kalkulation konnte nicht geladen werden.",
			initializing_calculation: "Kalkulation wird initialisiert...",
			member_source_offer_match: "Angebotsabgleich",
			member_source_manual: "Manuell",
			add_member: "Mitglied hinzufügen",
			delete_calculation_member_confirm_message:
				"Sind Sie sicher, dass Sie dieses Mitglied aus der Kalkulation entfernen möchten?",
			meta_data: "Metadaten",
			offer_number: "Angebotsnummer",
			project_name: "Projektname",
			block: "Block",
			add_block: "Block hinzufügen",
			block_quantity: "Menge (Multiplikator)",
			add_position: "Position hinzufügen",
			position_name: "Positionsname",
			add_service_to_block: "Leistung hinzufügen",
			manual_measurement: "Manuelles Ergebnis",
			use_manual_measurement: "Ergebnis direkt eingeben",
			use_dimensions: "Aus Maßen berechnen",
			not_found: "Diese Kalkulation existiert nicht mehr.",
			calculation_locked: "Diese Kalkulation ist gesperrt und kann nicht mehr bearbeitet werden.",
			reference_not_found: "Diese Kalkulation ist nicht mehr mit diesem Eintrag verknüpft.",
			item_not_found: "Eine der Leistungen gehört zu einer anderen Kalkulation.",
			position_not_found: "Eine der Positionen gehört zu einer anderen Leistung.",
			reference_approved:
				"Dieser Eintrag ist bereits freigegeben. Eine Kalkulation kann nicht mehr mit ihm verknüpft werden.",
			calculation_reported:
				"Diese Kalkulation ist in einem Partnerbericht verschickt und kann nicht mehr entsperrt werden.",
			lock: "Sperren",
			unlock: "Entsperren",
			lock_successful: "Kalkulation gesperrt",
			unlock_successful: "Kalkulation entsperrt",
			unlock_confirm_title: "Kalkulation entsperren?",
			unlock_confirm_message:
				"Die Kalkulation kann wieder bearbeitet werden. Wurde sie durch eine Freigabe gesperrt, bleibt sie entsperrt, bis die Freigabe zurückgenommen und neu erteilt wird.",
			locked_banner:
				"Gesperrt von {name} am {date}. Die Kalkulation kann nicht mehr bearbeitet werden.",
			locked_by_approval_banner:
				"Durch die Freigabe von {name} am {date} gesperrt. Die Kalkulation kann nicht mehr bearbeitet werden.",
		},
		permissions: {
			permissions: "Berechtigungen",
			permission: "Berechtigung",
			granted_by_role: "Über Rolle gewährt",
			successfully_updated: "Berechtigungen erfolgreich aktualisiert",
			failed_to_update: "Aktualisierung der Berechtigungen fehlgeschlagen",
			owner_role_note: "Eigentümer haben vollen Zugriff. Ihre Rolle kann nicht geändert werden.",
			owner_permissions_note:
				"Eigentümer haben vollen Zugriff. Ihre Berechtigungen können nicht bearbeitet werden.",
			wildcard_permissions_note:
				"Voller Zugriff durch {roles}. Individuelle Berechtigungen können nicht bearbeitet werden, solange die Rolle aktiv ist.",
			covered_by_role: "In einer Rolle enthalten",
			covered_by_roles: "Enthalten in: {roles}",
			from_roles: "aus {roles}",
			individually_extended: "Individuell erweitert",
			subjects: {
				stock: "Lager",
				contact: "Kontakte",
				contact_members: "Ansprechpartner",
				contact_projects: "Kundenprojekte",
				contact_services: "Kundenleistungen",
				employment: "Beschäftigungsdaten",
				vehicle: "Fahrzeuge",
				service: "Leistungen",
				partner: "Partner",
				team: "Teams",
				permission: "Berechtigungen",
				absence: "Abwesenheiten",
				attendance: "Zeiterfassung",
				user: "Mitarbeiter",
				invoice: "Rechnungen",
				incoming_invoice: "Eingangsrechnungen",
				ticket: "Tickets",
				measurement: "Aufmaße",
				calculation: "Kalkulationen",
				project: "Projekte",
				plan: "Plantafel",
				organization: "Organisation",
				file: "Dateien",
				note: "Notizen",
				integration: "Integrationen",
			},
			actions: {
				read: "Ansehen",
				create: "Anlegen",
				update: "Bearbeiten",
				delete: "Löschen",
				approve: "Freigeben",
				manage: "Verwalten",
			},
			you_are_not_authorized_to_access_this_page:
				"Sie sind nicht berechtigt, auf diese Seite zuzugreifen.",
			projects: {
				description:
					"Alle Berechtigungen, die sich allgemein auf Projekte und Tickets beziehen. Rechnungen und Dokumente sind nicht enthalten.",
				can_insert_label: "Kann anlegen",
				can_insert_description: "Kann Projekte anlegen.",
				can_insert_tickets_unaffiliated_label: "Kann Tickets anlegen",
				can_insert_tickets_unaffiliated_description:
					"Kann Tickets anlegen, bei denen der Benutzer nicht Bauleiter oder Stellvertreter ist.",
				can_delete_unaffiliated_label: "Kann löschen",
				can_delete_unaffiliated_description:
					"Kann Projekte und Tickets löschen, bei denen der Benutzer nicht Bauleiter oder Stellvertreter ist.",
				can_update_unaffiliated_label: "Kann bearbeiten",
				can_update_unaffiliated_description:
					"Kann Projekte und Tickets bearbeiten, bei denen der Benutzer nicht Bauleiter oder Stellvertreter ist.",
				can_read_unaffiliated_label: "Kann lesen",
				can_read_unaffiliated_description:
					"Kann fremde Projekte und Tickets lesen, bei denen der Benutzer nicht Bauleiter oder Stellvertreter ist.",
			},
			invoices: {
				description: "Alle Berechtigungen, die sich auf Rechnungen beziehen.",
				can_insert_label: "Kann anlegen",
				can_insert_description: "Kann Rechnungen anlegen.",
				can_delete_label: "Kann löschen",
				can_delete_description: "Kann Rechnungen löschen.",
				can_update_label: "Kann bearbeiten",
				can_update_description: "Kann Rechnungen bearbeiten.",
				can_read_label: "Kann lesen",
				can_read_description: "Kann Rechnungen lesen.",
			},
			contacts: {
				description: "Alle Berechtigungen, die sich auf Kontakte beziehen.",
				can_insert_label: "Kann anlegen",
				can_insert_description: "Kann Kontakte anlegen.",
				can_delete_label: "Kann löschen",
				can_delete_description: "Kann Kontakte löschen.",
				can_update_label: "Kann bearbeiten",
				can_update_description: "Kann Kontakte bearbeiten.",
				can_read_label: "Kann lesen",
				can_read_description: "Kann Kontakte lesen.",
			},
			partners: {
				description: "Alle Berechtigungen, die sich auf Partner beziehen.",
				can_send_report_label: "Kann Bericht senden",
				can_send_report_description: "Kann Partner-Zeitberichte senden.",
			},
			not_grantable: "Die Berechtigung {key} kann nicht vergeben werden.",
		},
		notifications: {
			kinds: {
				note_mention: "Erwähnung in einer Notiz",
				note_mention_description: "Wenn Sie jemand in einer Notiz erwähnt.",
				protocol_involvement: "Zu einem Protokoll hinzugefügt",
				protocol_involvement_description:
					"Wenn Sie jemand als Beteiligten zu einem Protokoll hinzufügt.",
				project_assigned: "Als Bauleiter eingeteilt",
				project_assigned_description: "Wenn Sie jemand zum Bauleiter eines Projekts macht.",
				project_number_changed: "Projektnummer geändert",
				project_number_changed_description:
					"Wenn sich die Nummer eines Projekts ändert, das Sie leiten.",
				order_complete: "Bestellung kommissioniert",
				order_complete_description:
					"Wenn eine Bestellung für ein Projekt, das Sie leiten, im Lager kommissioniert wurde.",
				plan_published: "Plan veröffentlicht",
				plan_published_description:
					"Wenn ein Plan, auf dem Sie eingeteilt sind, veröffentlicht oder geändert wird.",
				attendance_decided: "Anwesenheit bestätigt oder abgelehnt",
				attendance_decided_description:
					"Wenn eine Ihrer Anwesenheiten bestätigt oder abgelehnt wird.",
				substitution_assigned: "Als Vertretung eingeteilt",
				substitution_assigned_description:
					"Wenn Sie die Projekte einer abwesenden Kollegin oder eines abwesenden Kollegen übernehmen.",
				substitution_team_note: "Vertretungsliste für Ihr Team",
				substitution_team_note_description:
					"Wenn für jemanden aus Ihrem Team eine Vertretungsliste eingereicht wird.",
				substitution_external_note: "Wechsel des Ansprechpartners",
				substitution_external_note_description:
					"Wenn Ihr Ansprechpartner für ein Projekt abwesend ist und jemand anderes einspringt.",
				partner_report: "Partnerbericht",
				partner_report_description:
					"Eine Sammlung von PDFs mit Kalkulationen für externe Leistungen.",
				partnership_requested: "Partnerschaft angefragt",
				partnership_requested_description:
					"Wenn ein Unternehmen Ihren Partnerschaftscode einlöst und auf Ihre Aktivierung wartet.",
				partnership_activated: "Partnerschaft aktiviert",
				partnership_activated_description:
					"Wenn ein Auftraggeber die Partnerschaft aktiviert und Ihre Kolonnen ab dann einplanen kann.",
				partnership_deactivated: "Partnerschaft deaktiviert",
				partnership_deactivated_description:
					"Wenn ein Auftraggeber die Partnerschaft deaktiviert und keine Buchungen mehr möglich sind.",
				incoming_invoice_review_requested: "Eingangsrechnung zur Prüfung",
				incoming_invoice_review_requested_description:
					"Wenn eine Eingangsrechnung auf Ihre Prüfung wartet: sie ist eingegangen, wurde Ihnen übergeben, oder die Prüfkette hat Sie erreicht.",
				incoming_invoice_review_decided: "Übergebene Rechnung entschieden",
				incoming_invoice_review_decided_description:
					"Wenn jemand, dem Sie eine Eingangsrechnung übergeben haben, sie ablehnt – oder annimmt, ohne dass sie zu Ihnen zurückkommt. Kommt sie zurück, sagt es Ihnen die Prüfanfrage.",
			},
			groups: {
				notes: "Notizen",
				protocols: "Protokolle",
				projects: "Projekte",
				orders: "Bestellungen",
				planning: "Planung",
				attendances: "Anwesenheiten",
				substitutions: "Vertretungen",
				partners: "Partner",
				incoming_invoices: "Eingangsrechnungen",
			},
			preferences: {
				title: "Benachrichtigungen",
				description:
					"Legen Sie fest, welche Benachrichtigungen Sie per Push und per E-Mail erhalten.",
				push: "Push",
				email: "E-Mail",
				no_email_hint:
					"Ihr Konto hat keine E-Mail-Adresse, Sie erhalten daher nur Push-Benachrichtigungen.",
				not_available: "Nicht verfügbar",
				not_available_push: "Diese Benachrichtigung gibt es nicht als Push.",
				not_available_email: "Diese Benachrichtigung gibt es nicht als E-Mail.",
				saved: "Einstellungen gespeichert",
				channel_on: "An",
				channel_off: "Aus",
			},
			channels_not_offered: "Diese Benachrichtigungswege sind nicht verfügbar: {names}.",
		},
		emails: {
			preferences: {
				title: "E-Mail-Einstellungen",
				intro: "Wählen Sie, welche E-Mails an {email} gesendet werden.",
				receive: "Erhalten",
				save: "Speichern",
				saved_title: "Einstellungen gespeichert",
				saved_body: "Ihre Auswahl gilt ab sofort für jede E-Mail an {email}.",
				all_off: "Keine dieser E-Mails erhalten",
			},
			types: {
				partner_report: "Partnerbericht",
				partner_report_description:
					"Eine Sammlung von PDFs mit Kalkulationen für externe Leistungen.",
				note_mention: "Erwähnung in Notiz",
				note_mention_description: "Wird gesendet, wenn Sie jemand in einer Notiz erwähnt.",
				protocol_involvement: "Als Beteiligter hinzugefügt",
				protocol_involvement_description:
					"Wird gesendet, wenn Sie jemand als Beteiligten zu einem Protokoll hinzufügt.",
				order_complete: "Bestellung kommissioniert",
				order_complete_description:
					"Wird gesendet, wenn eine Bestellung für ein Projekt, das Sie leiten, im Lager kommissioniert wurde.",
				project_assigned: "Als Bauleiter eingetragen",
				project_assigned_description:
					"Wird gesendet, wenn Sie jemand als Bauleiter eines Projekts einträgt.",
				project_number_changed: "Projektnummer geändert",
				project_number_changed_description:
					"Wird gesendet, wenn sich die Nummer eines Projekts ändert, das Sie leiten.",
			},
			states: {
				bounced: "Unzustellbar",
				canceled: "Storniert",
				clicked: "Geklickt",
				complained: "Beanstandet",
				delivered: "Zugestellt",
				delivery_delayed: "Zustellung verzögert",
				failed: "Fehlgeschlagen",
				opened: "Geöffnet",
				queued: "In Warteschlange",
				scheduled: "Geplant",
				sent: "Gesendet",
			},
			greeting: {
				hello: "Hallo",
				mr: "Sehr geehrter Herr",
				mrs: "Sehr geehrte Frau",
			},
			unsubscribe: {
				hint: "Wenn Sie diese E-Mails nicht mehr erhalten möchten, klicken Sie bitte auf den folgenden Link, um Ihre E-Mail-Einstellungen zu verwalten.",
				manage: "E-Mail-Einstellungen verwalten",
			},
			note_mention: {
				subject: "{author} hat Sie in einer Notiz erwähnt – {kind} „{label}“",
				body: "{author} hat Sie in einer Notiz erwähnt.",
				parent: "{kind} „{label}“",
				note: "Notiz",
				open: "Öffnen",
			},
			protocol_involvement: {
				subject: "{type}: {title}",
				body: "{name} hat Sie als Beteiligten zu folgendem Protokoll hinzugefügt:",
				protocol: "{type} „{title}“",
				on_date: "{type} „{title}“ vom {date}",
				external_hint: "Das Protokoll wird Ihnen per E-Mail zugesandt, sobald es versendet wird.",
				open: "Protokoll öffnen",
			},
			order_complete: {
				subject: "Bestellung {number} für {project} kommissioniert",
				body: "{name} hat die Bestellung {number} für {project} vollständig kommissioniert. Die Ware steht zum Transport bereit.",
				delivery_date: "Liefertermin",
				open: "Bestellung öffnen",
			},
			project_assigned: {
				subject: "Sie sind Bauleiter für {number} {project}",
				body: "{name} hat Sie als Bauleiter für das Projekt {number} {project} eingetragen.",
				address: "Adresse",
				open: "Projekt öffnen",
			},
			project_number_changed: {
				subject: "Neue Projektnummer {number} für {project}",
				body: "{name} hat die Projektnummer von {project}, das Sie als Bauleiter führen, geändert.",
				previous_number: "Bisherige Nummer",
				new_number: "Neue Nummer",
				none: "keine",
				open: "Projekt öffnen",
			},
			partnership_requested: {
				subject: "{name} hat Ihren Partnerschaftscode eingelöst",
				title: "Partnerschaft angefragt",
				body: "{name} hat Ihren Partnerschaftscode eingelöst und wartet darauf, dass Sie die Partnerschaft aktivieren. Danach können Sie die Kolonnen dieses Unternehmens einplanen.",
				open: "Partner öffnen",
			},
			partnership_activated: {
				subject: "{name} hat die Partnerschaft aktiviert",
				title: "Partnerschaft aktiviert",
				body: "{name} hat die Partnerschaft aktiviert und kann Ihre Kolonnen ab jetzt einplanen.",
				open: "Partner öffnen",
			},
			partnership_deactivated: {
				subject: "{name} hat die Partnerschaft deaktiviert",
				title: "Partnerschaft deaktiviert",
				body: "{name} hat die Partnerschaft deaktiviert. Bis zur erneuten Aktivierung sind keine Buchungen mehr möglich.",
				open: "Partner öffnen",
			},
			incoming_invoice_review_requested: {
				subject: "Zur Prüfung: {invoice}",
				body_received: "{invoice} ist eingegangen und wartet auf Ihre Prüfung.",
				body_handed_over: "{name} hat Ihnen {invoice} zur Prüfung übergeben.",
				body_turn: "{invoice} liegt jetzt bei Ihnen zur Prüfung.",
				body_returned: "{name} hat {invoice} angenommen. Sie liegt wieder bei Ihnen zur Prüfung.",
				number: "Rechnungsnummer",
				issuer: "Rechnungssteller",
				amount: "Bruttobetrag",
				due_date: "Fälligkeit",
				workspace: "Workspace",
				handed_over_by: "Übergeben von",
				accepted_by: "Angenommen von",
				comment: "Kommentar",
				open: "Rechnung öffnen",
			},
			incoming_invoice_review_decided: {
				subject_approved: "{name} hat {invoice} angenommen",
				subject_rejected: "{name} hat {invoice} abgelehnt",
				body_approved:
					"{name} hat {invoice} angenommen. Sie hatten die Rechnung zur Prüfung übergeben.",
				body_rejected:
					"{name} hat {invoice} abgelehnt. Sie hatten die Rechnung zur Prüfung übergeben.",
				decision: "Entscheidung",
				approved: "Angenommen",
				rejected: "Abgelehnt",
				comment: "Kommentar",
				reason: "Begründung",
				number: "Rechnungsnummer",
				issuer: "Rechnungssteller",
				amount: "Bruttobetrag",
				due_date: "Fälligkeit",
				workspace: "Workspace",
				open: "Rechnung öffnen",
			},
			substitution_internal_note: {
				subject: "Projektvertretung - {name}",
				body: "auf Grund der Abwesenheit von {name} in dem Zeitraum {span} wurden Ihnen folgende Projekte zur Vertretung zugewiesen:",
				projects: "Projekte",
				note: "Notiz",
				open: "Öffnen",
			},
		},
		measurements: {
			show_closed_statements: "Geschlossene Aufmaße anzeigen",
			show_open_statements: "Offene Aufmaße anzeigen",
			open_measurement_list: "Aufmaßliste öffnen",
			measurements: "Aufmaße",
			statement: "Aufmaß",
			ticket_assignments_total: "Ticket-Zuweisungen (gesamt)",
			ticket_assignment_measurement_statements_total: "Aufmaße der Ticket-Zuweisungen (gesamt)",
			ticket_assignment_measurement_statements_open_total: "Aufmaße der Ticket-Zuweisungen (offen)",
			answered_by: "Beantwortet von",
			answered_at: "Beantwortet am",
			closed_by: "Geschlossen von",
			closed_at: "Geschlossen am",
			is_closed: "Ist geschlossen",
			is_open: "Ist offen",
			marked_as_closed: "Als geschlossen markiert",
			marked_as_open: "Als offen markiert",
			mark_selected_as_closed: "Ausgewählte als geschlossen markieren",
			mark_selected_as_open: "Ausgewählte als offen markieren",
			assignment_not_found: "Diese Ticket-Zuweisung gehört nicht zu diesem Projekt.",
			options: {
				remember: "Merken",
				without_charge: "Ohne Berechnung",
				included: "Inbegriffen",
			},
		},
		cost_centers: {
			add_cost_center: "Kostenstelle hinzufügen",
			cost_center: "Kostenstelle",
			cost_centers: "Kostenstellen",
			deactivated_instead: "Auf die Kostenstelle ist gebucht – sie wurde stattdessen deaktiviert",
			delete_cost_center_confirm_message:
				"Kostenstelle löschen? Ist auf sie gebucht, wird sie stattdessen deaktiviert.",
			edit_cost_center: "Kostenstelle bearbeiten",
			is_active: "Aktiv",
			name: "Bezeichnung",
			name_placeholder: "z. B. Gerüstbau Nord",
			number: "Nummer",
			number_placeholder: "z. B. 4100",
			select_cost_center: "Kostenstelle wählen",
		},
		dashboard: {
			hello: "Hallo {name}.",
			dashboard: "Dashboard",
			"7_days_forecast": "7-Tage-Vorschau",
			tickets_total_count: "Gesamt",
			user_tickets_count: "Eigene",
			today: "Heute",
			my_projects: "Meine Projekte",
			measurements: "Aufmaße",
			absences: "Abwesenheiten",
			weather: "Wetter",
			my_tasks: "Meine Aufgaben",
			invoice_approvals: "Rechnungsprüfungen",
			n_open_invoice_approvals: "{count} offen",
			partner_booking_reviews: "Buchungen prüfen",
			n_partner_booking_reviews: "{count} zu prüfen",
			partner_bookings_due: "Buchungen einreichen",
			n_partner_bookings_due: "{count} offen",
			notes: "Notizen",
			open_projects: "Offene Projekte",
			ticket_assignments: "Ticket-Zuweisungen",
			missing_statements: "Fehlende Aufmaße",
			yearly_statistics: "Jahresstatistik",
			invoice_total: "Rechnungssumme",
			invoices_paid: "Bezahlte Rechnungen",
			own_crews: "Eigene Kolonnen",
			partner_crews: "Partner-Kolonnen",
			protocols: "Protokolle",
			alerts: {
				level_types: {
					info: "Info",
					danger: "Gefahr",
					success: "Erfolg",
					warning: "Warnung",
					neutral: "Neutral",
				},
				delete_confirmation_message:
					"Möchten Sie diesen Alarm wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
				alerts: "Alarme",
				alert: "Alarm",
				alert_level: "Stufe",
				add_alert: "Alarm hinzufügen",
				edit_alert: "Alarm bearbeiten",
				missing_substitution_plan_title: "Handlung erforderlich: Vertretungsplan",
				missing_substitution_plan_description:
					"Bitte stellen Sie einen Vertretungsplan für den Zeitraum zwischen {startDate} und {endDate} bereit.",
				user_can_dismiss_alert: "Benutzer kann Alarm verwerfen",
				teams: "Teams",
			},
		},
		native: {
			grant_permission: "Berechtigung erteilen",
			grant_permission_camera: "Wir benötigen Ihre Erlaubnis, um die Kamera anzuzeigen",
		},
		video_recorder: {
			click_to_capture_video: "Klicken Sie hier, um ein Video aufzunehmen",
			recovery_title: "Nicht gesendete Aufnahme senden?",
			recovery_message:
				'{duration} von "{label}" haben die Unterbrechung überstanden. Sende sie jetzt oder lösche sie — an der Seite ändert sich so oder so nichts weiter.',
			recovery_lost_title: "Diese Aufnahme lässt sich nicht mehr senden",
			recovery_lost_message:
				'{duration} von "{label}" liegen noch hier, aber ihr Ziel gibt es nicht mehr — die Seite hält keinen Platz mehr dafür frei, also führt kein Weg mehr hin.',
			recovery_send: "Jetzt senden",
			recovery_busy: "Beende zuerst die laufende Aufnahme, dann kannst du diese senden.",
			recovery_delete: "Aufnahme löschen",
			capture_video: "Video aufnehmen",
			remaining: "noch {time}",
			stopped_at_limit:
				"Die Aufnahme hat die Grenze von {minutes} Minuten erreicht und wurde beendet. Das Aufgenommene bleibt erhalten.",
			screen_with_voice: "Bildschirm + Stimme",
			screen_with_camera: "Bildschirm + Kamera + Stimme",
			screen_silent: "Nur Bildschirm",
			camera_with_voice: "Kamera + Stimme",
			start_recording: "Aufnahme starten",
			start_failed: "Die Aufnahme konnte nicht gestartet werden. Bitte versuche es erneut.",
			stop_recording: "Aufnahme beenden",
			pause_recording: "Pausieren",
			resume_recording: "Fortsetzen",
			assembling_recording: "Aufnahme wird abgeschlossen…",
			recording_short: "Aufnahme",
			paused_short: "Pausiert",
			undock: "Außerhalb des Browsers sichtbar halten",
			can_trim_later: "Zuschneiden kannst du das Video später jederzeit auf der Seite.",
			retry_upload: "Erneut versuchen",
			open_target: "Zur Seite",
			discard_recording: "Verwerfen",
			recording: "Aufnahme läuft…",
			paused: "Pausiert — dein Bildschirm wird noch geteilt",
			camera_unavailable:
				'Kein Zugriff auf Kamera oder Mikrofon. Erlaube beides im Browser oder wähle „Nur Bildschirm".',
			microphone_unavailable:
				'Kein Zugriff auf das Mikrofon. Erlaube ihn im Browser oder wähle „Nur Bildschirm".',
		},
		videos: {
			already_rendering: "Dieses Video wird gerade neu berechnet.",
			cut_discard_original: "Original löschen",
			cut_end_handle: "Ende des behaltenen Teils",
			cut_failed_selection_kept: "Der Schnitt ist fehlgeschlagen. Deine Auswahl ist gesichert.",
			cut_here: "Hier schneiden",
			cut_keep_original: "Original behalten",
			cut_out_of_range: "Dieser Schnitt liegt außerhalb des Videos.",
			cut_overlapping:
				"Die behaltenen Bereiche müssen der Reihe nach liegen und dürfen sich nicht überlappen.",
			cut_rendering: "Schnitt wird angewendet…",
			cut_restore: "Diesen Teil zurückholen",
			cut_retry: "Schnitt erneut versuchen",
			cut_start_handle: "Anfang des behaltenen Teils",
			cut_too_short: "Ein Schnitt muss mindestens eine halbe Sekunde Video übrig lassen.",
			cut_video: "Video schneiden",
			insert_video: "Video einfügen",
			insert_image_failed: "Das Bild konnte nicht eingefügt werden.",
			insert_video_failed: "Das Video konnte nicht eingefügt werden.",
			not_found: "Dieses Video existiert nicht mehr.",
			not_ready: "Dieses Video ist noch nicht fertig verarbeitet.",
			not_uploadable: "Diese Aufnahme kann nicht mehr hochgeladen werden.",
			only_images_and_videos: "Nur Bild- und Videodateien werden unterstützt.",
			processing: "Wird verarbeitet…",
			processing_failed: "Die Verarbeitung dieses Videos ist fehlgeschlagen.",
			re_record: "Erneut aufnehmen",
			recording_in_progress: "Aufnahme läuft…",
			title: "Titel",
			upload_failed: "Der Upload ist fehlgeschlagen.",
			upload_media: "Bild/Video hochladen",
			upload_media_hint: "Bild- oder Videodatei auswählen oder hier ablegen",
			uploading: "Wird hochgeladen…",
			video: "Video",
		},
		stock: {
			my_orders: "Meine Bestellungen",
			stock: "Lager",
			catalogue: "Katalog",
			ordering: "Bestellwesen",
			logistics: "Logistik",
			articles: "Artikel",
			article: "Artikel",
			add_article: "Artikel hinzufügen",
			add_articles: "Artikel hinzufügen",
			vendor: "Lieferant",
			vendors: "Lieferanten",
			vendor_article_number: "Lieferantenartikelnummer",
			add_vendor_article: "Lieferantenartikel hinzufügen",
			edit_vendor_article: "Lieferantenartikel bearbeiten",
			edit_article: "Artikel bearbeiten",
			article_groups: "Artikelgruppen",
			article_group: "Artikelgruppe",
			article_group_number: "Artikelgruppennummer",
			add_article_group: "Artikelgruppe hinzufügen",
			edit_article_group: "Artikelgruppe bearbeiten",
			select_article_group: "Artikelgruppe auswählen",
			article_product_type: "Artikelproduktart",
			article_product_types: "Artikelproduktarten",
			article_product_type_number: "Artikelproduktartnummer",
			select_product_type: "Produktart auswählen",
			add_article_product_type: "Artikelproduktart hinzufügen",
			edit_article_product_type: "Artikelproduktart bearbeiten",
			article_group_has_no_product_types: "Artikelgruppe hat keine Produktarten",
			article_no: "Artikel-Nr.",
			order_no: "Nummer",
			auto_generate_number: "Nummer automatisch generieren",
			number_is_already_taken:
				"Diese Nummer ist bereits vergeben. Möchten Sie stattdessen die verfügbare {number} verwenden?",
			create_order_template: "Bestellvorlage erstellen",
			order_templates: "Bestellvorlagen",
			edit_order_template: "Bestellvorlage bearbeiten",
			delete_order_template: "Bestellvorlage löschen",
			number_of_articles: "Anzahl der Artikel",
			count_articles: "{count} Artikel",
			delete_order_template_confirmation:
				"Möchten Sie diese Bestellvorlage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			add_order: "Bestellung hinzufügen",
			edit_order: "Bestellung bearbeiten",
			cancel_order: "Bestellung stornieren",
			orders: "Bestellungen",
			order_id: "Bestell-ID",
			suborders: "Teilbestellungen",
			n_suborders: "{count} Teilbestellungen",
			suborder_id: "Teilbestellungs-ID",
			select_articles: "Artikel auswählen",
			insert_template_articles: "Vorlagenartikel einfügen",
			successfully_inserted_template_articles: "Vorlagenartikel erfolgreich eingefügt",
			inserting_template_articles_failed: "Einfügen der Vorlagenartikel fehlgeschlagen",
			delivery: "Lieferung",
			delivery_date: "Lieferdatum",
			delivery_window: "Lieferfenster",
			tours: "Touren",
			tour: "Tour",
			tour_wave: "Tourwelle",
			tour_waves: "Tourwellen",
			add_tour_wave: "Tourwelle hinzufügen",
			edit_tour_wave: "Tourwelle bearbeiten",
			purchase_price: "Einkaufspreis",
			cutoff_offset: "Vorlaufzeit",
			deadline: "Frist",
			delete_tour_wave_confirmation:
				"Möchten Sie diese Tourwelle wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			delete_order_confirmation:
				"Möchten Sie diese Bestellung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			delete_suborder_confirmation:
				"Möchten Sie diese Teilbestellung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
			cutoff_time_helper_text:
				"Eine Bestellung für diese Tour an einem {weekday} müsste vor dem {cutoffDate} aufgegeben werden.",
			these_article_numbers_couldnt_be_resolved:
				"Die folgenden Artikelnummern konnten nicht aufgelöst werden. Bitte informieren Sie Ihren Administrator, damit die fehlenden Artikel in der Datenbank ergänzt werden.",
			warehouse_zones: "Lagerzonen",
			all_warehouse_zones: "Alle Zonen",
			start_picking: "Kommissionierung starten",
			already_picked_of_required: "{picked} von {required} bereits kommissioniert",
			picking: "Kommissionierung",
			warehouse_zone: "Lagerzone",
			warehouse_locations: "Lagerplätze",
			warehouse_location: "Lagerplatz",
			available_quantity: "Hier verfügbar",
			required: "Benötigt",
			picked: "Kommissioniert",
			ordered: "Bestellt",
			booked_out: "Gebucht",
			booked_at: "Gebucht am",
			planned: "Geplant",
			over_picked_by: "{overage} mehr kommissioniert als bestellt.",
			open_in_other_zones: "{quantity} werden in einem anderen Lagerbereich geholt.",
			still_needed: "Noch benötigt",
			article_has_no_image: "Kein Bild",
			shipping_labels: "Versandetiketten",
			no_shipping_labels:
				"Noch keine Versandetiketten — sie entstehen beim Abschluss einer Kommissionierrunde.",
			add_warehouse_zone: "Lagerzone hinzufügen",
			edit_warehouse_zone: "Lagerzone bearbeiten",
			delete_warehouse_zone: "Lagerzone löschen",
			has_location: "Hat Lagerplatz",
			warehouse_zone_shelf_size: "Regalgröße",
			warehouse_zone_axis_size: "Achsengröße",
			warehouse_zone_floor_size: "Ebenengröße",
			warehouse_zone_label: "Etikett",
			warehouse_zone_label_failed: "Dieses Etikett konnte nicht erzeugt werden.",
			unknown_warehouse_zone: "Dieser Code gehört zu keinem Lagerbereich eures Lagers.",
			warehouse_zone_number: "Zonennummer",
			warehouse_shelf: "Regal",
			warehouse_axis: "Achse",
			warehouse_floor: "Ebene",
			warehouse_zone_type: {
				warehouse_zone_type: "Lagerzonentyp",
				consolidation: "Konsolidierung",
				receiving: "Wareneingang",
				shipping: "Warenausgang",
				staging: "Bereitstellung",
				storage: "Lagerung",
			},
			select_warehouse_locations: "Lagerplätze auswählen",
			order_state: {
				order_state: "Bestellstatus",
				pending: "Ausstehend",
				open: "Offen",
				in_progress: "In Bearbeitung",
				completed: "Abgeschlossen",
				picking: "Kommissionierung",
				canceled: "Storniert",
			},
			release_order: "Bestellung freigeben",
			recall_order: "Bestellung zurückrufen",
			restore_order: "Bestellung wiederherstellen",
			restoring_order: "Bestellung wird wiederhergestellt...",
			restoring_order_failed: "Wiederherstellung der Bestellung fehlgeschlagen...",
			restoring_order_successful: "Bestellung erfolgreich wiederhergestellt...",
			cancelling_order: "Bestellung wird storniert...",
			cancelling_order_failed: "Stornierung der Bestellung fehlgeschlagen...",
			cancelling_order_successful: "Bestellung erfolgreich storniert...",
			cancel_order_confirmation_message:
				"Möchten Sie diese Bestellung und alle zugehörigen Teilbestellungen wirklich stornieren? Diese Aktion kann von einem Administrator rückgängig gemacht werden.",
			restore_order_confirmation_message:
				"Möchten Sie diese Bestellung wirklich wiederherstellen? Sie und alle zugehörigen Teilbestellungen werden wieder auf offen gesetzt.",
			book_pick: "Kommissionierung buchen",
			scanned_shelf_not_listed: "Dieser Lagerplatz gehört nicht zu diesem Artikel.",
			finish_picking: "Kommissionierung abschließen",
			picked_quantity_over_open_quantity:
				"Es werden {overage} mehr gebucht, als diese Position benötigt.",
			picked_from_here: "{quantity} von diesem Lagerplatz kommissioniert.",
			picking_summary: "Zusammenfassung",
			picking_signoff: "Abschluss",
			picking_signoff_locked:
				"Der Abschluss öffnet sich, sobald jede Position kommissioniert und jedes bestellte Leergut gedeckt ist.",
			picking_signoff_hint:
				"Prüfe die Runde, bevor du sie übergibst. Mit dem Abschluss werden die Ladungsträger aus dem Hof gebucht.",
			signoff_article_lines: "Positionen",
			signoff_no_carriers: "Es gehen keine Ladungsträger mit.",
			picking_summary_locked:
				"Die Zusammenfassung öffnet sich, sobald alle Positionen kommissioniert sind.",
			picked_of_required: "{picked} von {required} kommissioniert",
			still_needed_quantity: "Noch {quantity} benötigt",
			picked_quantity: "Kommissionierte Menge",
			open_quantity: "Offene Menge",
			stock_balance: "Lagerbestand",
			quantity_on_location: "An diesem Lagerplatz",
			articles_on_location: "Artikel",
			location_stock_balance: "Am Lagerplatz",
			reserved_quantity: "Reserviert",
			orderable_quantity: "Bestellbar",
			warning_stock_balance: "Warnbestand",
			minimum_stock_balance: "Mindestbestand",
			requires_transfer_carrier_on_return: "Benötigt Transferbehälter bei Rückführung",
			article_has_no_warehouse_location:
				"Dieser Artikel hat noch keinen Lagerplatz. Bitte zuerst einen zuweisen.",
			no_receiving_zone:
				"Es ist keine Warenannahme eingerichtet. Bitte zuerst eine Lagerzone vom Typ „Wareneingang“ anlegen.",
			transfer_carrier_required:
				"Dieser Artikel muss auf einem Transferbehälter zurückgeführt werden.",
			transfer_carrier: "Transferbehälter",
			transfer_carriers: "Transferbehälter",
			scan_transfer_carrier: "Transferbehälter scannen",
			scan_transfer_carrier_description:
				"Nummer auf dem Wagen scannen, auf den das Material geladen wurde.",
			unknown_transfer_carrier: "Dieser Transferbehälter gehört nicht zu eurem Lager.",
			transfer_carrier_in_use:
				"Auf diesem Transferbehälter steht noch Material. Bitte zuerst einlagern.",
			add_transfer_carrier: "Transferbehälter anlegen",
			edit_transfer_carrier: "Transferbehälter bearbeiten",
			delete_transfer_carrier: "Transferbehälter löschen",
			delete_transfer_carrier_confirmation:
				"Soll dieser Transferbehälter wirklich gelöscht werden? Das kann nicht widerrufen werden.",
			transfer_carrier_no: "Behälter-Nr.",
			transfer_carrier_not_loaded: "Dieser Transferbehälter konnte nicht geladen werden.",
			transfer_carriers_empty: "Es wurde noch kein Transferbehälter angelegt.",
			transfer_carrier_current_zone: "Steht in",
			transfer_carrier_number_hint: "Leer lassen, um die nächste freie Nummer zu verwenden.",
			transfer_carrier_open_legs: "Darauf",
			transfer_carrier_history: "Einlagerungen",
			transfer_carrier_history_empty: "Dieser Transferbehälter hat noch nichts transportiert.",
			scan_transfer_carrier_button: "Transferbehälter scannen",
			transfer_carrier_label: "Etikett",
			transfer_carrier_label_hint:
				"Ausdrucken und auf den Behälter kleben. Der Code wird zum Be- und Entladen gescannt.",
			transfer_carrier_label_failed: "Dieses Etikett konnte nicht erzeugt werden.",
			download_transfer_carrier_label: "Etikett herunterladen",
			transfer_carrier_scanned: "Transferbehälter {name}",
			transfer_carrier_spans_return_orders:
				"Auf diesem Transferbehälter liegen Ladungen aus mehreren Rückführungsaufträgen.",
			scanned_code_unknown:
				"Dieser Code gehört weder zu einem Rückführungsauftrag noch zu einem Transferbehälter eures Lagers.",
			put_away_to_shelf: "Auf Lagerplatz {location}",
			put_away_raised: "Einlagerung angelegt",
			put_away_complete: "Eingelagert",
			put_away_nothing_open: "Auf diesem Transferbehälter steht nichts.",
			put_away_carried_by_hand: "Von Hand getragen",
			put_away: "Einlagerung",
			put_aways: "Einlagerungen",
			put_away_open: "Einzulagern",
			put_away_destination: "Nach",
			put_away_claim_trolley: "Transferbehälter übernehmen",
			put_away_progress: "{done} / {total} eingelagert",
			put_away_spans_return_orders: "Ladungen aus {count} Rückführungsaufträgen",
			scan_warehouse_location_description:
				"Etikett des Lagerplatzes scannen, auf den das Material gestellt wird.",
			scan_warehouse_location_button: "Lagerplatz scannen",
			warehouse_location_scanned: "Lagerplatz {name}",
			shelf_not_assigned_to_article:
				"Dieser Artikel ist dem gescannten Lagerplatz nicht zugeordnet. Zuerst zuordnen.",
			article_quantity_state: {
				article_quantity_state: "Bestandszustand",
				ok: "OK",
				low: "Niedrig",
				critical: "Kritisch",
				empty: "Leer",
			},
			transactions: "Transaktionen",
			transaction: "Transaktion",
			operations: {
				operations: "Vorgänge",
				operation: "Vorgang",
				add: "Hinzufügen",
				remove: "Entfernen",
			},
			transaction_types: {
				transaction_type: "Transaktionstyp",
				correction: "Korrektur",
				pick: "Kommissionierung",
				inventory: "Inventur",
				restock: "Nachschub",
				return: "Rückgabe",
			},
			article_size: "Artikelgröße",
			leergut: "Leergut",
			ordered_load_carriers_not_picked:
				"Für diesen Auftrag fehlt noch Leergut. Bitte mindestens die bestellte Menge kommissionieren, bevor die Runde abgeschlossen wird.",
			load_carriers_ordered_minimum: "Mindestens {quantity} bestellt",
			no_warehouse_zone: "Ohne Lagerbereich",
			load_carriers: "Ladungsträger",
			load_carrier: "Ladungsträger",
			load_carrier_size: "Maße",
			add_load_carrier: "Ladungsträger hinzufügen",
			edit_load_carrier: "Ladungsträger bearbeiten",
			carriers_step_hint:
				"Tippe einen Ladungsträger an, um die Menge festzulegen. Gebucht wird erst beim Abschluss der Kommissionierung.",
			carriers_in_the_yard: "{quantity} im Hof",
			summary_continue: "Weiter zu Ladungsträgern",
			carriers_continue: "Weiter zum Abschluss",
			carriers_going_along_title: "Ladungsträger",
			delete_load_carrier: "Ladungsträger löschen",
			delete_load_carrier_confirmation:
				"Diesen Ladungsträger löschen? Die gesamte Bewegungshistorie geht mit — jeder Wareneingang, jeder Rückläufer und jede Korrektur, die den Bestand erklärt haben.",
			book_load_carrier_movement: "Bewegung buchen",
			quantity_is_over_orderable_quantity: "Nur {available} bestellbar.",
			insufficient_available_stock:
				"Nicht genügend Bestand bestellbar. Eine andere Bestellung hat ihn bereits reserviert — neu laden und Mengen prüfen.",
			order_not_cancellable:
				"Diese Bestellung wird bereits kommissioniert und kann nicht mehr storniert werden. Nur eine noch nicht ans Lager freigegebene Bestellung lässt sich stornieren.",
			order_not_restorable: "Nur eine stornierte Bestellung kann wiederhergestellt werden.",
			order: "Bestellung",
			suborder: "Teilbestellung",
			follow_up_zone: "Folgebereich",
			follow_up_zone_description:
				"Wohin ein Ladungsträger geht, wenn er diesen Bereich verlässt. Leer lassen, wo die Kette endet — bei einem Verladebereich ist das der Normalfall.",
			follow_up_zone_cycle:
				"Dieser Folgebereich führt zurück zu diesem Bereich, Ladungsträger würden also im Kreis laufen. Wähle einen anderen oder ändere zuerst dessen Folgebereich.",
			home_zone: "Standplatz",
			home_zone_description:
				"Wo diese Ladungsträger stehen, wenn sie leer sind. Eine reine Leergut-Bestellung hat keinen Kommissionierbereich — das hier gibt ihrem Transport einen Startpunkt.",
			transport_orders: "Transportaufträge",
			transport_order: "Transportauftrag",
			non_storage_warehouse_zone:
				"Artikel können nur in einem Lagerbereich vom Typ Lager bestandsführend sein. Verschiebe den Lagerplatz zuerst in einen Lagerbereich oder wähle einen anderen.",
			transport_order_state: {
				pending: "Abzuholen",
				"in-transit": "Unterwegs",
				complete: "Zugestellt",
				canceled: "Storniert",
			},
			transport_mine: "Meine",
			transport_taken_over: "Übernommen",
			transport_taken_over_message:
				"{carrier} war schon mit jemand anderem unterwegs. Jetzt gehört er dir — bring ihn nach {zone}.",
			transport_scan_title: "Etikett scannen",
			transport_scan_hint:
				"Versandetikett scannen, um den Ladungsträger zu übernehmen. Am nächsten Halt erneut scannen, sobald er abgestellt ist.",
			transport_picked_up: "Übernommen",
			transport_delivered: "Zugestellt",
			transport_picked_up_message: "{carrier} nach {zone} bringen.",
			transport_delivered_message: "{carrier} steht in {zone}.",
			transport_next_stop: "Nächster Halt: {zone}",
			transport_chain_ended: "Dieser Ladungsträger ist angekommen. Nichts mehr zu tun.",
			transport_carrier: "Träger",
			transport_from_zone: "Von",
			transport_order_no: "Transport-Nr.",
			transport_scan_zone: "Wo stehst du?",
			transport_scan_zone_description:
				"Etikett von {zone} scannen, um zu bestätigen, dass du dort stehst.",
			transport_scan_zone_confirm: "Bestätigen",
			scan_warehouse_zone_button: "Lagerbereich scannen",
			warehouse_zone_scanned: "Bereich {name}",
			wrong_warehouse_zone: "Hier kann dieser Ladungsträger nicht bewegt werden.",
			wrong_warehouse_zone_title: "Falscher Bereich",
			wrong_warehouse_zone_go_to: "{carrier} in {zone} scannen.",
			wrong_warehouse_zone_retry: "Erneut scannen",
			transport_to_zone: "Nach",
			transport_picked_up_by: "Übernommen von",
			transport_delivered_by: "Zugestellt von",
			transport_open_legs: "{count} offen",
			no_transport_orders: "Keine Transportaufträge",
			no_transport_orders_hint:
				"Ladungsträger erscheinen hier, sobald eine Kommissionierung in einem Bereich abgeschlossen wird, der einen Folgebereich hat.",
			cancel_transport_order: "Transportauftrag stornieren",
			cancel_transport_order_confirm_message:
				"Diesen Transportauftrag stornieren? Der Ladungsträger bleibt, wo er ist, und es wird kein Folgeauftrag erstellt.",
			unknown_shipping_label:
				"Dieses Etikett gehört nicht zu eurem Lager. Prüfe, ob es eines von euren ist.",
			transport_order_already_closed:
				"Dieser Ladungsträger ist bereits angekommen — es gibt nichts mehr zu transportieren.",
			order_not_loaded: "Diese Bestellung konnte nicht geladen werden.",
			suborder_not_loaded: "Diese Teilbestellung konnte nicht geladen werden.",
			order_completed: "Bestellung abgeschlossen",
			name_has_completed_order_for_project:
				"{name} hat Bestellung {number} für {project} kommissioniert",
			protocol: "Protokoll",
			protocol_created: "Angelegt",
			protocol_level_order: "Bestellung",
			protocol_level_round: "Runde {number}",
			protocol_unattributed: "Unbekannt",
			protocol_from_state: "Von",
			protocol_to_state: "Nach",
			filter_state: "Zustand",
			filter_state_all: "Alle Zustände",
			filter_reset: "Filter zurücksetzen",
			transport_event: {
				raised: "Erstellt",
				picked_up: "Übernommen",
				taken_over: "Weitergegeben",
				delivered: "Zugestellt",
				canceled: "Storniert",
			},
			transport_events: "Übergabekette",
			transport_event_history: "Übergabekette",
			transport_taken_over_from: "Übernommen von {name}",
			returns: "Rückführungsaufträge",
			return_order: "Rückführungsauftrag",
			return_orders: "Rückführungsaufträge",
			return_order_no: "Rückführungsnr.",
			add_return_order: "Rückführungsauftrag anlegen",
			add_return_order_description:
				"Rückführungsauftrag für eine Baustelle anlegen, die abgebaut wird. Für den LKW wird ein Blatt gedruckt.",
			return_order_not_loaded: "Dieser Rückführungsauftrag konnte nicht geladen werden.",
			return_orders_empty: "Es wurde noch kein Rückführungsauftrag angelegt.",
			return_order_state: {
				open: "Offen",
				"in-progress": "In Arbeit",
				complete: "Abgeschlossen",
				canceled: "Storniert",
			},
			return_vehicles: "Fahrzeuge",
			return_vehicles_none: "Noch nicht zugeordnet",
			return_add_vehicle: "Fahrzeug hinzufügen",
			return_remove_vehicle: "Fahrzeug entfernen",
			return_edit_vehicles: "Fahrzeuge bearbeiten",
			return_reconciliation: "Abgleich",
			return_shipped: "Geliefert",
			return_returned: "Zurück",
			return_received: "An Warenannahme",
			return_outstanding: "Noch auf Baustelle",
			return_last_picked_from: "Kommissioniert von",
			return_book: "Rückgabe buchen",
			return_book_quantity: "Zurückgegebene Menge",
			return_book_location: "Zurück auf",
			return_booked: "Gebucht",
			return_complete_order: "Rückführungsauftrag abschließen",
			return_complete_order_confirm_message:
				"Diesen Rückführungsauftrag abschließen? Danach kann nichts mehr darauf gebucht werden.",
			return_cancel_order: "Rückführungsauftrag stornieren",
			return_cancel_order_confirm_message:
				"Diesen Rückführungsauftrag stornieren? Was bereits gebucht wurde, bleibt im Regal — die Ware steht im Haus.",
			return_print_sheet: "Blatt erneut drucken",
			return_scan_sheet: "Rückführungsblatt scannen",
			return_scan_sheet_description: "QR-Code auf dem Blatt aus dem LKW scannen.",
			return_unknown_sheet: "Dieses Blatt gehört nicht zu eurem Lager.",
			return_net_zero: "Alles zurück",
			return_over_returned: "Mehr zurück als geliefert",
			return_sheets: "Rückführungsblatt",
			no_return_sheets:
				"Noch kein Blatt — beim Druck des Rückführungsauftrags wird eines abgelegt.",
			article_not_found: "Dieser Artikel existiert nicht mehr.",
			article_group_not_found: "Diese Artikelgruppe existiert nicht mehr.",
			article_product_type_not_found: "Diese Artikelproduktart existiert nicht mehr.",
			article_location_not_found: "Dieser Artikel ist diesem Lagerplatz nicht mehr zugewiesen.",
			vendor_article_not_found: "Dieser Lieferantenartikel existiert nicht mehr.",
			vendor_not_found: "Dieser Lieferant existiert nicht mehr. Bitte wählen Sie einen anderen.",
			order_template_not_found: "Diese Bestellvorlage existiert nicht mehr.",
			order_not_found: "Diese Bestellung existiert nicht mehr.",
			order_project_not_found:
				"Das Projekt dieser Bestellung existiert nicht mehr. Bitte wählen Sie ein anderes.",
			suborder_not_found: "Diese Teilbestellung existiert nicht mehr.",
			suborder_state_changed:
				"Diese Teilbestellung hat sich inzwischen geändert. Laden Sie neu, um den aktuellen Stand zu sehen.",
			suborder_not_picking:
				"Diese Teilbestellung wird gerade nicht kommissioniert, daher kann keine Entnahme darauf gebucht werden.",
			article_not_in_order: "Diese Bestellung enthält diesen Artikel nicht.",
			tour_wave_not_found: "Diese Tourwelle existiert nicht mehr.",
			return_order_not_found: "Dieser Rückführungsauftrag existiert nicht mehr.",
			return_order_closed:
				"Dieser Rückführungsauftrag ist bereits abgeschlossen. Es kann nichts mehr darauf gebucht werden.",
			load_carrier_not_found: "Dieser Ladungsträger existiert nicht mehr.",
			transfer_carrier_not_found: "Dieser Transferbehälter existiert nicht mehr.",
			warehouse_location_not_found: "Dieser Lagerplatz existiert nicht mehr.",
			warehouse_zone_not_found: "Diese Lagerzone existiert nicht mehr.",
			follow_up_zone_not_found:
				"Der gewählte Folgebereich existiert nicht mehr. Bitte wählen Sie einen anderen.",
		},
		terminals: {
			enter_pin_prompt: "PIN eingeben, um ein- oder auszuchecken",
			not_checked_in: "Nicht eingecheckt",
			today: "Heute",
			today_total: "Heute gesamt",
			week_total: "Diese Woche",
			now: "Jetzt",
			terminal_worksite: "Arbeitsort des Terminals",
			terminal_worksite_description:
				"Anwesenheiten, die an diesem Terminal gebucht werden, zählen auf diesen Arbeitsort.",
			approve_terminal: "Terminal genehmigen",
			approve_terminal_description:
				"Scannen Sie den QR-Code, der auf dem zu genehmigenden Terminal angezeigt wird.",
			approving_terminal: "Terminal wird genehmigt...",
			terminal_approved_successfully: "Terminal erfolgreich genehmigt",
			approving_terminal_failed: "Genehmigung des Terminals fehlgeschlagen",
			pairing_request_not_found:
				"Für dieses Terminal liegt keine Genehmigungsanfrage vor. Starten Sie das Terminal neu und scannen Sie den QR-Code erneut.",
		},
	},
};
